import {
  Component,
  EventEmitter,
  HostListener,
  Inject,
  Injector,
  Input,
  OnInit,
  Output,
  TemplateRef,
} from "@angular/core";
import { NgxTippyProps } from "ngx-tippy-wrapper";

import { Router } from "@angular/router";
import { TuiDialogService } from "@taiga-ui/core";
import * as CryptoJS from "crypto-js";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { dropdownValues } from "src/app/core/services/config.service";
import { EventDataService } from "src/app/core/services/event-data.service";
import { ApiService } from "src/app/core/services/shared/api.service";
import { GlobalVarService } from "src/app/core/services/shared/global-var.service";

import {
  Answer,
  CodehelpService,
  ConfigMapService,
  Searchconfig,
} from "virtue-form";
import { TooltippopupComponent } from "../shared/tooltippopup/tooltippopup.component";

import { PolymorpheusComponent } from "@tinkoff/ng-polymorpheus";
import { NotificationService } from "src/app/core/services/shared/notification.service";
import { PredefineArrayListService } from "src/app/core/services/shared/predefine-array-list.service";
import { CollegeNameSearchBoxComponent } from "../shared/dialog/college-name-search-box/college-name-search-box.component";
import { CollegeprofileComponent } from "../shared/dialog/collegeprofile/collegeprofile.component";
import { MailmeComponent } from "../shared/dialog/mailme/mailme.component";
import { ResultNotepopupComponent } from "../shared/dialog/result-notepopup/result-notepopup.component";
import {
  DropdownData,
  StateAidData,
  StudentSelectedCollege,
  UniversityList,
  collegeWiseProgramList,
  federalAidData,
  meritScholerShipData,
} from "./../../core/models/Result";
export interface FederalAndState {
  isEligible: boolean;
  isIncluded: boolean;
  isCalculated: boolean;
  amount: number;
  meritName: string;
  collegeName: string;
  exactAmount: number;
  yearOfGridUsedForCalculation: string;
}
@Component({
  selector: "app-result",
  templateUrl: "./result.component.html",
  styleUrls: ["./result.component.scss"],
})
export class ResultComponent implements OnInit {
  @Output() updateSectionTitleEvent = new EventEmitter<number>();
  @Input() answerMap!: Map<Number, Answer>;

  desiredStudeyDDL: any = [];
  year = new Date().getFullYear();
  desiredStudeyModelValue: string = "";

  studentProfileArr: any = [];
  universityDataDisplayOptions: any;
  isCartView: boolean = true;
  result: any = {};
  basepath = "";
  universityList: any;
  costofAttendance = "Cost of Attendance";
  costOfAttendanceData: Array<UniversityList> = [];
  meritScholerShipData: Array<meritScholerShipData> = [];
  searchAutocompleteList: Array<DropdownData> = [];
  collegeWiseProgramList: Array<collegeWiseProgramList> = [];
  collegeWiseAgeOfEarningList: Array<any> = [];
  ComparisionList: Array<UniversityList> = [];
  collegeWise4YearTotalExpensesLifeTimeList: Array<any> = [];
  isShowcollegeWise4YearTotalExpensesLifeTimeList = false;

  isOpenMeritInfoRange = false;
  isMailMe: boolean = true;
  isShowCollegeWiseProgramList = false;
  isShowCollegeWiseAgeOfEarningList = false;
  componentPageData: any;

  federalAidData: Array<federalAidData> = [];
  StateAidData: Array<StateAidData> = [];
  programName: string;
  costOfAttendanceFilterAmount: [] = [];
  tippyProps = {
    placement: "top-end",
    arrow: false,
    theme: "light",
  };

  tippyPropsLeft = {
    placement: "top-start",
    arrow: false,
    theme: "light",
  };
  tootipData: string[] = [];

  ocrScholarshipsDataList: any[] = [];
  ocrCoaDataList: any[] = [];
  showOcrCoaDataBucket: boolean[] = [];
  isShowIpedsData: boolean[] = [];

  showOcrScholarshipsDataBucket: boolean[] = [];
  public baseProps: NgxTippyProps = {
    arrow: true,
    theme: "light",
    delay: 500,
  };

  templateRef: NgxTippyProps = {
    ...this.baseProps,
    allowHTML: true,
    appendTo: "parent",
    interactive: true,
    interactiveBorder: 50,
  };
  passInnerHTML: NgxTippyProps = this.templateRef;

  isLogin: boolean;
  showOcrData: boolean[] = [];
  data = {};
  grantData: any;
  //
  scholarshipList: any = [];
  successMessage: string = "";
  universityData: UniversityList;
  ComparisionMatrixList: any = [];
  showBreakdown: boolean = true;
  studentSelectedCollegeList: Array<StudentSelectedCollege> = [];
  // answerMap:Map<Number,Answer>= new Map();
  @Output() inputwidgetoutput = new EventEmitter<Answer>();
  @Output() removewidgetInput = new EventEmitter<number>();
  // @Output() validated = new EventEmitter<FieldInfo>();
  @Input() mergedUniversityList: Array<UniversityList>;

  isIPEDSToggle: boolean = false;
  isShowAwardLetterDDL: boolean[] = [];
  isShowNPCData: boolean[] = [];
  feedbacks: any;
  feedbackFormSubmit = false;
  feedbackData: any = {};
  modalRef: BsModalRef;
  skipItems: any = ["Need Aid", "Royal Merit Scholarship Qualification"];
  video: string = "";
  applyUrlforModal: string;
  stateCalculatorList: any = [];

  // basepath: string = "";
  constructor(
    private codehelp: CodehelpService,
    private configmap: ConfigMapService,
    private notificatioService: NotificationService,
    private router: Router,
    public globalvar: GlobalVarService,
    private modalService: BsModalService,
    private eventDataService: EventDataService,
    private predefineArray: PredefineArrayListService,
    public apiService: ApiService,
    @Inject(TuiDialogService) private readonly dialogService: TuiDialogService,
    @Inject(Injector) private readonly injector: Injector
  ) {
    this.basepath = this.globalvar.basepath;
    // this.universityDataDisplayOptions =
    //   this.predefineArray.universityDataDisplayOptions;
    // if (this.basepath === "top5") {
    //   this.predefineArray.yearWiseCollegeROIData.splice(
    //     this.predefineArray.yearWiseCollegeROIData.length - 2,
    //     2
    //   );
    // }
  }

  checkVisibleIpedsData() {
    let value = false;
    for (let index = 0; index < this.universityList.length; index++) {
      if (this.isShowIpedsData[index]) {
        value = true;
      }
    }
    return value;
  }

  ngOnChanges() {
    this.getCollegeData();
  }

  setOptionSelectDDl(index: string) {
    if (
      this.showOcrScholarshipsDataBucket[index] ||
      this.showOcrCoaDataBucket[index]
    ) {
      let List = this.predefineArray.ddlWithAwardletter;
      return List;
    }
    //  else {
    //   let List = this.predefineArray.ddlWithOutAwardletter;
    //   return List;
    // }
  }

  getSortbyCollegeRavi() {
    let List = [];
    List = this.getCardViewArrayList();
    if (this.globalvar.collegeSortBy == "By_Rank") {
      let acsOrderClgDistance = [];
      let notAvailableClgDistance = [];

      List.forEach((element) => {
        if (element?.dropDownData?.collegeRankInUS) {
          acsOrderClgDistance.push(element);
        } else {
          notAvailableClgDistance.push(element);
        }
      });

      acsOrderClgDistance.sort((a: any, b: any) => {
        let fa = a?.dropDownData?.collegeRankInUS,
          fb = b?.dropDownData?.collegeRankInUS;
        if (fa < fb) {
          return -1;
        }
        if (fa > fb) {
          return 1;
        }

        return 0;
      });

      List = [...acsOrderClgDistance, ...notAvailableClgDistance];
    }

    if (this.globalvar.collegeSortBy == "By_Cost") {
      List.sort((a: any, b: any) => {
        let fa = a?.dropDownData?.outOfPocketCost,
          fb = b?.dropDownData?.outOfPocketCost;
        if (fa < fb) {
          return -1;
        }
        if (fa > fb) {
          return 1;
        }
        return 0;
      });
    }

    if (this.globalvar.collegeSortBy == "By_Grant") {
      List.sort((a: any, b: any) => {
        let fa = a?.dropDownData?.totalGrant,
          fb = b?.dropDownData?.totalGrant;
        if (fa > fb) {
          return -1;
        }
        if (fa < fb) {
          return 1;
        }
        return 0;
      });
    }

    if (this.globalvar.collegeSortBy == "By_Alphabet_A_Z") {
      List.sort((a: any, b: any) => {
        let fa = a?.dropDownData?.name.toLowerCase(),
          fb = b?.dropDownData?.name.toLowerCase();
        if (fa < fb) {
          return -1;
        }
        if (fa > fb) {
          return 1;
        }
        return 0;
      });
    }
    if (this.globalvar.collegeSortBy == "By_Alphabet_Z_A") {
      List.sort((a: any, b: any) => {
        let fa = a?.dropDownData?.name.toLowerCase(),
          fb = b?.dropDownData?.name.toLowerCase();
        if (fa > fb) {
          return -1;
        }
        if (fa < fb) {
          return 1;
        }
        return 0;
      });
    }
    let searchExtraCollegeList = [];
    if (List.length > 5) {
      let mergedStr = JSON.stringify(List);
      searchExtraCollegeList = JSON.parse(mergedStr);
      List.splice(5, List.length);
      searchExtraCollegeList.splice(0, 5);
      this.universityList = List;
      this.searchAutocompleteList = searchExtraCollegeList;
    }
  }
  getSortbyCollege() {
    let list = this.getCardViewArrayList();

    const sortByOptions = {
      By_Rank: "collegeRankInUS",
      By_Cost: "outOfPocketCost",
      By_Grant: "totalGrant",
      By_Alphabet_A_Z: "name",
      By_Alphabet_Z_A: "name",
    };

    const sortByField = sortByOptions[this.globalvar.collegeSortBy];

    if (this.globalvar.collegeSortBy === "By_Rank") {
      list = this.sortByRank(list);
    } else if (this.globalvar.collegeSortBy === "By_Cost") {
      list = this.sortByField(list, sortByField);
    } else if (this.globalvar.collegeSortBy === "By_Grant") {
      list = this.sortByField(list, sortByField, "desc");
    } else if (
      this.globalvar.collegeSortBy === "By_Alphabet_A_Z" ||
      this.globalvar.collegeSortBy === "By_Alphabet_Z_A"
    ) {
      list = this.sortByName(
        list,
        this.globalvar.collegeSortBy === "By_Alphabet_A_Z"
      );
    }

    this.updateUniversityList1(list);
  }

  private sortByRank(list) {
    const acsOrderClgDistance = list.filter(
      (element) => element?.dropDownData?.collegeRankInUS
    );
    const notAvailableClgDistance = list.filter(
      (element) => !element?.dropDownData?.collegeRankInUS
    );

    acsOrderClgDistance.sort(
      (a, b) =>
        a?.dropDownData?.collegeRankInUS - b?.dropDownData?.collegeRankInUS
    );

    return [...acsOrderClgDistance, ...notAvailableClgDistance];
  }

  private sortByField(list, field, order = "asc") {
    return list.sort((a, b) => {
      const fa = a?.dropDownData?.[field];
      const fb = b?.dropDownData?.[field];
      return order === "asc" ? fa - fb : fb - fa;
    });
  }

  private sortByName(list, ascending) {
    return list.sort((a, b) => {
      const fa = a?.dropDownData?.name.toLowerCase();
      const fb = b?.dropDownData?.name.toLowerCase();
      return ascending ? fa.localeCompare(fb) : fb.localeCompare(fa);
    });
  }

  private updateUniversityList1(list) {
    let searchExtraCollegeList = [];

    if (list.length > 5) {
      searchExtraCollegeList = list.slice(5);
      list = list.slice(0, 5);
    }

    this.universityList = list;
    this.searchAutocompleteList = searchExtraCollegeList;
  }

  // sortCollegeData() {
  //   let clgList = [];
  //   let collegeData = this.universityList;

  //   this.collegeCardViewList = collegeData;
  // }

  getCollegeData1() {
    if (this.mergedUniversityList != undefined) {
      if (this.mergedUniversityList.length) {
        this.eventDataService.answerMap.subscribe(
          (answerValue: Map<Number, Answer>) => {
            if (answerValue) {
              this.answerMap = answerValue;
            }
          }
        );
        // this.eventDataService.hanleAnswerMap(this.answerMap);
        this.universityList = [];
        this.universityList = this.mergedUniversityList;

        if (
          this.universityList[0]?.["SearchCollegeFilterList"] != undefined &&
          this.universityList[0]?.["SearchCollegeFilterList"].length > 0
        ) {
          //this.globalvar.searchSelectedCollegeList=[];
          this.searchAutocompleteList =
            this.universityList[0]?.["SearchCollegeFilterList"];
        }
        this.studentSelectedCollegeList = [];
        this.getSortbyCollege();
        // console.log(this.universityList);
        this.universityList.forEach((element, index) => {
          let outOfPocketCost = this.getOutOfPocketAmountSort(
            element?.dropDownData
          );
          this.universityList[index].dropDownData.outOfPocketCost =
            outOfPocketCost;
          if (
            this.universityList[index]?.dropDownData?.result?.totalGrant?.amount
          ) {
            this.universityList[index].dropDownData.totalGrant =
              this.getMeritHeaderAmount1(
                this.universityList[index]?.dropDownData?.result?.totalGrant
                  ?.amount,
                index
              );
          }
        });

        for (const x in this.universityList) {
          if (
            this.universityList[x]?.dropDownData["StudentSelectedCollege"] !=
            undefined
          ) {
            this.studentSelectedCollegeList.push(
              this.universityList[x].dropDownData["StudentSelectedCollege"]
            );

            // this.sendMail();
          }

          // this.universityList[x].dropDownData["institutionAidAmountSum"] = 0;
          // this.universityList[x].dropDownData["meritScholarshipGiftAid"] = 0;
          // this.universityList[x].dropDownData["outOfPocketCost"] = 0;

          // if (
          //   this.universityList[x].hasOwnProperty("ocrDataScholarshipItems")
          // ) {
          //   if (
          //     Object.keys(this.universityList[x]["ocrDataScholarshipItems"])
          //       .length > 1
          //   ) {
          //     this.showOcrScholarshipsDataBucket[x] = true;
          //     this.showOcrData[x] = true;
          //   }
          // }

          // if (this.universityList[x].hasOwnProperty("ocrDataCoaItems")) {
          //   if (
          //     Object.keys(this.universityList[x]["ocrDataCoaItems"]).length > 2
          //   ) {
          //     this.showOcrCoaDataBucket[x] = true;
          //     this.showOcrData[x] = true;
          //   }
          // }
          this.setOCRAwardLetterData(x);
        }

        this.updateOcrScholarshipDataKeyList();
        this.updateOcrCoaDataKeyList();
        this.getIpedsCostOfAttendanceData(); //get cost of attendance data
        this.getInstGrantData(); //get merit and need data
        if (this.globalvar.isInternatinalStudent == false) {
          this.getFederalAidData(); //get federal and fseog data
          this.getStateAidData(); //get state grand
        }
        this.Comparision();
        let program = this.answerMap.get(35);
        if (program != undefined) {
          this.getProgramName(program.value);
        }
        this.getCollegeWiseProgramList();
        this.getCollegeWiseAgeofEarningList();
        // this.getCollegeWise4YearTotalExpensesList();  // comment for not use this chart data 28_April_2023 Ravi
        this.apiService.updateClientTraffic();
      }
    }
  }
  getCollegeData() {
    if (!this.mergedUniversityList || this.mergedUniversityList.length === 0) {
      return;
    }

    this.eventDataService.answerMap.subscribe(
      (answerValue: Map<number, Answer>) => {
        if (answerValue) {
          this.answerMap = answerValue;
        }
      }
    );

    this.initializeUniversityList();
    this.updateSearchAutocompleteList();

    this.studentSelectedCollegeList = [];
    // this.getSortbyCollege();
    this.getSortbyCollege();
    // this.updateUniversityList();

    this.universityList.forEach((element, index) => {
      const outOfPocketCost = this.getOutOfPocketAmountSort(
        element?.dropDownData
      );
      this.universityList[index].dropDownData.outOfPocketCost = outOfPocketCost;

      const totalGrantAmount =
        this.universityList[index]?.dropDownData?.result?.totalGrant?.amount;
      if (totalGrantAmount) {
        this.universityList[index].dropDownData.totalGrant =
          this.getMeritHeaderAmount1(totalGrantAmount, index);
      }
    });

    this.updateStudentSelectedCollegeList();

    for (const x in this.universityList) {
      if (
        this.universityList[x]?.dropDownData?.StudentSelectedCollege !=
        undefined
      ) {
        this.studentSelectedCollegeList.push(
          this.universityList[x].dropDownData.StudentSelectedCollege
        );
      }
      this.setOCRAwardLetterData(x);
    }

    this.updateOcrScholarshipDataKeyList();
    this.updateOcrCoaDataKeyList();
    this.getIpedsCostOfAttendanceData();
    this.getInstGrantData();

    if (!this.globalvar.isInternatinalStudent) {
      this.getFederalAidData();
      this.getStateAidData();
    }

    this.Comparision();
    this.getProgramName(this.answerMap?.get(35)?.value);
    this.getCollegeWiseProgramList();
    this.getCollegeWiseAgeofEarningList();
    this.apiService.updateClientTraffic();
  }

  private initializeUniversityList() {
    this.universityList = [...this.mergedUniversityList];
  }

  private updateSearchAutocompleteList() {
    if (
      this.universityList[0]?.SearchCollegeFilterList != undefined &&
      this.universityList[0]?.SearchCollegeFilterList.length > 0
    ) {
      this.searchAutocompleteList =
        this.universityList[0]?.SearchCollegeFilterList;
    }
  }

  private updateUniversityList() {
    this.universityList.forEach((element, index) => {
      this.updateUniversityListDetails(element, index);
    });
  }

  private updateUniversityListDetails(element, index) {
    let outOfPocketCost = this.getOutOfPocketAmountSort(element?.dropDownData);
    this.universityList[index].dropDownData.outOfPocketCost = outOfPocketCost;

    const totalGrantAmount =
      this.universityList[index]?.dropDownData?.result?.totalGrant?.amount;
    if (totalGrantAmount) {
      this.universityList[index].dropDownData.totalGrant =
        this.getMeritHeaderAmount1(totalGrantAmount, index);
    }
  }

  private updateStudentSelectedCollegeList() {
    this.studentSelectedCollegeList = this.universityList
      .filter(
        (university) =>
          university?.dropDownData?.StudentSelectedCollege != undefined
      )
      .map((university) => university.dropDownData.StudentSelectedCollege);
  }

  getOutOfPocketAmountSort(clgData: any) {
    let costOfAttendanceAmount = 0;
    let meritScholarShipAmt = 0;
    let costofAttendanceList = clgData["npcCollegeCostProfile"];
    let meritScholerShipGrantList = clgData?.result?.totalGrant;
    if (meritScholerShipGrantList?.amount != undefined) {
      meritScholarShipAmt = meritScholerShipGrantList?.amount;
    }
    let affinityAmt = this.getAffinityAmount(clgData?.yearWiseAffinityQuestion);
    if (affinityAmt) {
      meritScholarShipAmt += affinityAmt;
    }
    let stateGrantData = clgData?.["result"]?.stateAid;
    let selectedStateCode = clgData?.StudentSelectedCollege;
    if (stateGrantData != undefined) {
      let grntAmt = Number(
        this.setStateAidandGrandAmount(stateGrantData, selectedStateCode)
      );
      meritScholarShipAmt += grntAmt;
    }
    for (let index = 0; index < costofAttendanceList.length; index++) {
      const row = costofAttendanceList[index];
      if (row.fieldNo == "50") {
        costOfAttendanceAmount = row.value;
      }
    }
    let outOfPocketCost = costOfAttendanceAmount - meritScholarShipAmt;
    return outOfPocketCost > 0 ? outOfPocketCost : 0;
  }

  set(keys: any, value: any) {
    var key = CryptoJS.enc.Utf8.parse(keys);
    var iv = CryptoJS.enc.Utf8.parse(keys);
    var encrypted = CryptoJS.AES.encrypt(
      CryptoJS.enc.Utf8.parse(value.toString()),
      key,
      {
        keySize: 128 / 8,
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    );

    return encrypted.toString();
  }

  //The get method is use for decrypt the value.
  get(keys: any, value: any) {
    var key = CryptoJS.enc.Utf8.parse(keys);
    var iv = CryptoJS.enc.Utf8.parse(keys);
    var decrypted = CryptoJS.AES.decrypt(value, key, {
      keySize: 128 / 8,
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    return decrypted.toString(CryptoJS.enc.Utf8);
  }

  // Comparision() {
  //   this.ComparisionMatrixList = [];
  //   let meritScholerShipList: any = [];
  //   for (
  //     let index = 0;
  //     index < this.predefineArray.yearWiseCollegeROIData.length;
  //     index++
  //   ) {
  //     const YearWiseCollegeROIData =
  //       this.predefineArray.yearWiseCollegeROIData[index];
  //     let graduationvalue = [];
  //     let meritCostwithLabel: any = [];
  //     for (const x in this.universityList) {
  //       if (
  //         this.universityList[x].dropDownData?.yearWiseCollegeROIData !=
  //         undefined
  //       ) {
  //         if (
  //           this.universityList[x].dropDownData?.yearWiseCollegeROIData[
  //             "2022"
  //           ] != undefined
  //         ) {
  //           let GraduationRate =
  //             this.universityList[x].dropDownData?.yearWiseCollegeROIData[
  //               "2022"
  //             ];

  //           if (GraduationRate) {
  //             Object.keys(GraduationRate).forEach((key) => {
  //               if (
  //                 YearWiseCollegeROIData?.value == key &&
  //                 YearWiseCollegeROIData?.fieldno == 888888
  //               ) {
  //                 if (GraduationRate[key]?.value) {
  //                   let costs = this.setValueWithPercentage(
  //                     GraduationRate[key]?.value
  //                   );

  //                   let c = {
  //                     amount: costs,
  //                   };
  //                   graduationvalue.push(c);
  //                 } else {
  //                   let c = {
  //                     amount: "-",
  //                   };
  //                   graduationvalue.push(c);
  //                 }
  //               } else {
  //                 if (
  //                   YearWiseCollegeROIData?.value == key &&
  //                   YearWiseCollegeROIData?.fieldno == 1
  //                 ) {
  //                   if (GraduationRate[key]?.[10]?.value) {
  //                     let costs = this.dollarformat(
  //                       GraduationRate[key]?.[10]?.value
  //                     );
  //                     let c = {
  //                       amount: costs,
  //                     };
  //                     graduationvalue.push(c);
  //                   } else {
  //                     let c = {
  //                       amount: "-",
  //                     };
  //                     graduationvalue.push(c);
  //                   }
  //                 }
  //                 if (
  //                   YearWiseCollegeROIData?.value == key &&
  //                   YearWiseCollegeROIData.fieldno == 2
  //                 ) {
  //                   if (GraduationRate[key]?.[40]?.value) {
  //                     let costs = this.dollarformat(
  //                       GraduationRate[key]?.[40]?.value
  //                     );
  //                     let c = {
  //                       amount: costs,
  //                     };
  //                     graduationvalue.push(c);
  //                   } else {
  //                     let c = {
  //                       amount: "-",
  //                     };
  //                     graduationvalue.push(c);
  //                   }
  //                 }
  //                 if (
  //                   YearWiseCollegeROIData?.value == key &&
  //                   YearWiseCollegeROIData?.fieldno == 66
  //                 ) {
  //                   if (GraduationRate[key]) {
  //                     let costs = this.setValueWithPercentage(
  //                       GraduationRate[key]
  //                     );
  //                     let c = {
  //                       amount: costs,
  //                     };
  //                     graduationvalue.push(c);
  //                   } else {
  //                     let c = {
  //                       amount: "-",
  //                     };
  //                     graduationvalue.push(c);
  //                   }
  //                 }
  //                 if (
  //                   YearWiseCollegeROIData?.value == key &&
  //                   YearWiseCollegeROIData?.fieldno == 3
  //                 ) {
  //                   if (GraduationRate[key]) {
  //                     let costs = GraduationRate[key];
  //                     let c = {
  //                       amount: costs,
  //                     };
  //                     graduationvalue.push(c);
  //                   } else {
  //                     let c = {
  //                       amount: "-",
  //                     };
  //                     graduationvalue.push(c);
  //                   }
  //                 }
  //                 if (
  //                   YearWiseCollegeROIData?.value == key &&
  //                   YearWiseCollegeROIData.fieldno == 777777
  //                 ) {
  //                   if (GraduationRate[key]) {
  //                     let costs = this.setValueWithPercentage(
  //                       GraduationRate[key]
  //                     );
  //                     let c = {
  //                       amount: costs,
  //                     };
  //                     graduationvalue.push(c);
  //                   } else {
  //                     let c = {
  //                       amount: "-",
  //                     };
  //                     graduationvalue.push(c);
  //                   }
  //                 }
  //               }
  //             });
  //           } else {
  //             graduationvalue.push("-");
  //           }
  //         }
  //       } else {
  //         graduationvalue.push("-");
  //       }
  //     }

  //     meritCostwithLabel = {
  //       label: YearWiseCollegeROIData.label,
  //       amount: graduationvalue,
  //       tooltip: YearWiseCollegeROIData.tooltip,
  //     };
  //     meritScholerShipList.push(meritCostwithLabel);
  //   }
  //   this.ComparisionMatrixList = meritScholerShipList;
  // }

  // Comparision() {
  //   this.ComparisionMatrixList = [];

  //   let meritScholerShipList: any = [];

  //   for (
  //     let index = 0;
  //     index < this.predefineArray.yearWiseCollegeROIData.length;
  //     index++
  //   ) {
  //     const YearWiseCollegeROIData =
  //       this.predefineArray.yearWiseCollegeROIData[index];

  //     let graduationvalue = [];

  //     let meritCostwithLabel: any = [];

  //     for (const x in this.universityList) {
  //       if (
  //         this.universityList[x].dropDownData?.yearWiseCollegeROIData !=
  //         undefined
  //       ) {
  //         if (
  //           this.universityList[x].dropDownData?.yearWiseCollegeROIData[
  //             "year"
  //           ] != undefined
  //         ) {
  //           let GraduationRate =
  //             this.universityList[x].dropDownData?.yearWiseCollegeROIData[
  //               "year"
  //             ];

  //           Object.keys(GraduationRate).forEach((key) => {
  //             if (
  //               YearWiseCollegeROIData.value == key &&
  //               YearWiseCollegeROIData.fieldno == 888888
  //             ) {
  //               if (GraduationRate[key]?.value) {
  //                 let costs = this.setValueWithPercentage(
  //                   GraduationRate[key].value
  //                 );

  //                 let c = {
  //                   amount: costs,

  //                   inputType: "per",
  //                 };

  //                 graduationvalue.push(c);
  //               } else {
  //                 let c = {
  //                   amount: "-",

  //                   inputType: "per",
  //                 };

  //                 graduationvalue.push(c);
  //               }
  //             } else {
  //               if (
  //                 YearWiseCollegeROIData.value == key &&
  //                 YearWiseCollegeROIData.fieldno == 1
  //               ) {
  //                 if (GraduationRate[key]?.[10]?.value) {
  //                   // let costs = this.dollarformat(
  //                   //   GraduationRate[key]?.[10].value
  //                   // );
  //                   let costs = GraduationRate[key]?.[10].value;
  //                   let c = {
  //                     amount: costs,

  //                     inputType: "num",
  //                   };

  //                   graduationvalue.push(c);
  //                 } else {
  //                   let c = {
  //                     amount: null,

  //                     inputType: "num",
  //                   };

  //                   graduationvalue.push(c);
  //                 }
  //               }

  //               if (
  //                 YearWiseCollegeROIData?.value == key &&
  //                 YearWiseCollegeROIData.fieldno == 2
  //               ) {
  //                 let ageOfEarningobj = this.universityList[x]?.dropDownData
  //                   ?.CollegeWiseProgramList?.programWiseROIData
  //                   ? this.universityList[x]?.dropDownData
  //                       ?.CollegeWiseProgramList?.programWiseROIData[0]
  //                       ?.estEarnings
  //                   : this.universityList[x]?.dropDownData
  //                       ?.CollegeWiseProgramList?.programWiseROIData;

  //                 if (ageOfEarningobj != undefined) {
  //                   if (ageOfEarningobj.length > 0) {
  //                     let costs = ageOfEarningobj[0]?.value; // let costs = this.dollarformat(GraduationRate[key]?.[40]?.value);

  //                     let c = {
  //                       amount: costs,

  //                       inputType: "num",
  //                     };

  //                     graduationvalue.push(c);
  //                   } else {
  //                     let c = {
  //                       amount: null,

  //                       inputType: "num",
  //                     };

  //                     graduationvalue.push(c);
  //                   }
  //                 }
  //                 //   if (GraduationRate[key]?.[40]?.value) {
  //                 //   let costs = GraduationRate[key]?.[40]?.value; // let costs = this.dollarformat(GraduationRate[key]?.[40]?.value);

  //                 //   let c = {
  //                 //     amount: costs,

  //                 //     inputType: "num",
  //                 //   };

  //                 //   graduationvalue.push(c);
  //                 // }
  //                 else {
  //                   let c = {
  //                     amount: null,

  //                     inputType: "num",
  //                   };

  //                   graduationvalue.push(c);
  //                 }
  //               }

  //               if (
  //                 YearWiseCollegeROIData.value == key &&
  //                 YearWiseCollegeROIData.fieldno == 66
  //               ) {
  //                 if (GraduationRate[key]) {
  //                   let costs = this.setValueWithPercentage(
  //                     GraduationRate[key]
  //                   );

  //                   let c = {
  //                     amount: costs,

  //                     inputType: "per",
  //                   };

  //                   graduationvalue.push(c);
  //                 } else {
  //                   let c = {
  //                     amount: "-",

  //                     inputType: "per",
  //                   };

  //                   graduationvalue.push(c);
  //                 }
  //               }

  //               if (
  //                 YearWiseCollegeROIData.value == key &&
  //                 YearWiseCollegeROIData.fieldno == 3
  //               ) {
  //                 if (GraduationRate[key]) {
  //                   let costs = GraduationRate[key];

  //                   let c = {
  //                     amount: costs,

  //                     inputType: "label",
  //                   };

  //                   graduationvalue.push(c);
  //                 } else {
  //                   let c = {
  //                     amount: "-",

  //                     inputType: "label",
  //                   };

  //                   graduationvalue.push(c);
  //                 }
  //               }

  //               if (
  //                 YearWiseCollegeROIData?.value == key &&
  //                 YearWiseCollegeROIData.fieldno == 777777
  //               ) {
  //                 if (GraduationRate[key]) {
  //                   let costs = this.setValueWithPercentage(
  //                     GraduationRate[key]
  //                   );

  //                   let c = {
  //                     amount: costs,

  //                     inputType: "per",
  //                   };

  //                   graduationvalue.push(c);
  //                 } else {
  //                   let c = {
  //                     amount: "-",

  //                     inputType: "per",
  //                   };

  //                   graduationvalue.push(c);
  //                 }
  //               }
  //             }
  //           });
  //         }
  //       } else {
  //         let c = {
  //           amount: null,
  //           inputType: "label",
  //         };
  //         graduationvalue.push(c);
  //       }
  //     }

  //     meritCostwithLabel = {
  //       label: YearWiseCollegeROIData.label,

  //       amount: graduationvalue,

  //       tooltip: YearWiseCollegeROIData.tooltip,
  //     };

  //     meritScholerShipList.push(meritCostwithLabel);
  //   }

  //   this.ComparisionMatrixList = meritScholerShipList;
  // }
  // Comparision() {
  //   this.ComparisionMatrixList = [];
  //   let meritScholarshipList: any = [];

  //   for (
  //     let index = 0;
  //     index < this.predefineArray.yearWiseCollegeROIData.length;
  //     index++
  //   ) {
  //     const YearWiseCollegeROIData =
  //       this.predefineArray.yearWiseCollegeROIData[index];
  //     let graduationvalue = [];
  //     let meritCostwithLabel: any = [];

  //     for (const x in this.universityList) {
  //       if (
  //         this.universityList[x].dropDownData?.yearWiseCollegeROIData !==
  //         undefined
  //       ) {
  //         if (
  //           this.universityList[x].dropDownData?.yearWiseCollegeROIData[
  //             "year"
  //           ] !== undefined
  //         ) {
  //           let GraduationRate =
  //             this.universityList[x].dropDownData?.yearWiseCollegeROIData[
  //               "year"
  //             ];

  //           // Check if the key exists in GraduationRate
  //           if (
  //             GraduationRate &&
  //             YearWiseCollegeROIData.value in GraduationRate
  //           ) {
  //             const graduationRateValue =
  //               GraduationRate[YearWiseCollegeROIData.value];
  //             const graduationRateAmount = this.getValueForField(
  //               graduationRateValue,
  //               YearWiseCollegeROIData.fieldno
  //             );
  //             graduationvalue.push(graduationRateAmount);
  //           } else {
  //             // If the key doesn't exist, set amount to null and inputType to "label"
  //             graduationvalue.push({ amount: null, inputType: "label" });
  //           }
  //         } else {
  //           graduationvalue.push({ amount: null, inputType: "label" });
  //         }
  //       } else {
  //         graduationvalue.push({ amount: null, inputType: "label" });
  //       }
  //     }

  //     meritCostwithLabel = {
  //       label: YearWiseCollegeROIData.label,
  //       amount: graduationvalue,
  //       tooltip: YearWiseCollegeROIData.tooltip,
  //     };

  //     meritScholarshipList.push(meritCostwithLabel);
  //   }

  //   this.ComparisionMatrixList = meritScholarshipList;
  //   console.log(this.ComparisionMatrixList, "Comparison");
  // }
  // Ravi code
  // Comparision() {
  //   this.ComparisionMatrixList = [];

  //   let meritScholerShipList: any = [];

  //   for (
  //     let index = 0;
  //     index < this.predefineArray.yearWiseCollegeROIData.length;
  //     index++
  //   ) {
  //     const YearWiseCollegeROIData =
  //       this.predefineArray.yearWiseCollegeROIData[index];

  //     let graduationvalue = [];

  //     let meritCostwithLabel: any = [];

  //     for (const x in this.universityList) {
  //       if (
  //         this.universityList[x].dropDownData?.yearWiseCollegeROIData !=
  //         undefined
  //       ) {
  //         if (
  //           this.universityList[x].dropDownData?.yearWiseCollegeROIData[
  //             "year"
  //           ] != undefined
  //         ) {
  //           let GraduationRate =
  //             this.universityList[x].dropDownData?.yearWiseCollegeROIData[
  //               "year"
  //             ];

  //           Object.keys(GraduationRate).forEach((key) => {
  //             if (
  //               YearWiseCollegeROIData.value == key &&
  //               YearWiseCollegeROIData.fieldno == 888888
  //             ) {
  //               if (GraduationRate[key]?.value) {
  //                 let costs = this.setValueWithPercentage(
  //                   GraduationRate[key].value
  //                 );

  //                 let c = {
  //                   amount: costs,

  //                   inputType: "per",
  //                 };

  //                 graduationvalue.push(c);
  //               } else {
  //                 let c = {
  //                   amount: "-",

  //                   inputType: "per",
  //                 };

  //                 graduationvalue.push(c);
  //               }
  //             } else {
  //               if (
  //                 YearWiseCollegeROIData.value == key &&
  //                 YearWiseCollegeROIData.fieldno == 1
  //               ) {
  //                 if (GraduationRate[key]?.[10]?.value) {
  //                   // let costs = this.dollarformat(
  //                   //   GraduationRate[key]?.[10].value
  //                   // );
  //                   let costs = GraduationRate[key]?.[10].value;
  //                   let c = {
  //                     amount: costs,

  //                     inputType: "num",
  //                   };

  //                   graduationvalue.push(c);
  //                 } else {
  //                   let c = {
  //                     amount: null,

  //                     inputType: "num",
  //                   };

  //                   graduationvalue.push(c);
  //                 }
  //               }

  //               if (
  //                 YearWiseCollegeROIData?.value == key &&
  //                 YearWiseCollegeROIData.fieldno == 2
  //               ) {
  //                 let ageOfEarningobj = this.universityList[x]?.dropDownData
  //                   ?.CollegeWiseProgramList?.programWiseROIData
  //                   ? this.universityList[x]?.dropDownData
  //                       ?.CollegeWiseProgramList?.programWiseROIData[0]
  //                       ?.estEarnings
  //                   : this.universityList[x]?.dropDownData
  //                       ?.CollegeWiseProgramList?.programWiseROIData;

  //                 if (ageOfEarningobj != undefined) {
  //                   if (ageOfEarningobj.length > 0) {
  //                     let costs = ageOfEarningobj[0]?.value; // let costs = this.dollarformat(GraduationRate[key]?.[40]?.value);

  //                     let c = {
  //                       amount: costs,

  //                       inputType: "num",
  //                     };

  //                     graduationvalue.push(c);
  //                   } else {
  //                     let c = {
  //                       amount: null,

  //                       inputType: "num",
  //                     };

  //                     graduationvalue.push(c);
  //                   }
  //                 }
  //                 //   if (GraduationRate[key]?.[40]?.value) {
  //                 //   let costs = GraduationRate[key]?.[40]?.value; // let costs = this.dollarformat(GraduationRate[key]?.[40]?.value);

  //                 //   let c = {
  //                 //     amount: costs,

  //                 //     inputType: "num",
  //                 //   };

  //                 //   graduationvalue.push(c);
  //                 // }
  //                 else {
  //                   let c = {
  //                     amount: null,

  //                     inputType: "num",
  //                   };

  //                   graduationvalue.push(c);
  //                 }
  //               }

  //               if (
  //                 YearWiseCollegeROIData.value == key &&
  //                 YearWiseCollegeROIData.fieldno == 66
  //               ) {
  //                 if (GraduationRate[key]) {
  //                   let costs = this.setValueWithPercentage(
  //                     GraduationRate[key]
  //                   );

  //                   let c = {
  //                     amount: costs,

  //                     inputType: "per",
  //                   };

  //                   graduationvalue.push(c);
  //                 } else {
  //                   let c = {
  //                     amount: "-",

  //                     inputType: "per",
  //                   };

  //                   graduationvalue.push(c);
  //                 }
  //               }

  //               if (
  //                 YearWiseCollegeROIData.value == key &&
  //                 YearWiseCollegeROIData.fieldno == 3
  //               ) {
  //                 if (GraduationRate[key]) {
  //                   let costs = GraduationRate[key];

  //                   let c = {
  //                     amount: costs,

  //                     inputType: "label",
  //                   };

  //                   graduationvalue.push(c);
  //                 } else {
  //                   let c = {
  //                     amount: "-",

  //                     inputType: "label",
  //                   };

  //                   graduationvalue.push(c);
  //                 }
  //               }

  //               if (
  //                 YearWiseCollegeROIData?.value == key &&
  //                 YearWiseCollegeROIData.fieldno == 777777
  //               ) {
  //                 if (GraduationRate[key]) {
  //                   let costs = this.setValueWithPercentage(
  //                     GraduationRate[key]
  //                   );

  //                   let c = {
  //                     amount: costs,

  //                     inputType: "per",
  //                   };

  //                   graduationvalue.push(c);
  //                 } else {
  //                   let c = {
  //                     amount: "-",

  //                     inputType: "per",
  //                   };

  //                   graduationvalue.push(c);
  //                 }
  //               }
  //             }
  //           });
  //         }
  //       } else {
  //         let c = {
  //           amount: null,
  //           inputType: "label",
  //         };
  //         graduationvalue.push(c);
  //       }
  //     }

  //     meritCostwithLabel = {
  //       label: YearWiseCollegeROIData.label,

  //       amount: graduationvalue,

  //       tooltip: YearWiseCollegeROIData.tooltip,
  //     };

  //     meritScholerShipList.push(meritCostwithLabel);
  //   }

  //   this.ComparisionMatrixList = meritScholerShipList;
  // }
  Comparision() {
    this.ComparisionMatrixList = [];

    let meritScholerShipList: any = [];

    for (
      let index = 0;
      index < this.predefineArray.yearWiseCollegeROIData.length;
      index++
    ) {
      const YearWiseCollegeROIData =
        this.predefineArray.yearWiseCollegeROIData[index];

      let graduationvalue = [];

      let meritCostwithLabel: any = [];

      console.log(this.universityList, "hritik university list")

      for (const x in this.universityList) {
        if (
          this.universityList[x].dropDownData?.yearWiseCollegeROIData !=
          undefined
        ) {
          if (
            this.universityList[x].dropDownData?.yearWiseCollegeROIData[
              "year"
            ] != undefined
          ) {
            let GraduationRate =
              this.universityList[x].dropDownData?.yearWiseCollegeROIData[
                "year"
              ];

            if (!(YearWiseCollegeROIData.value in GraduationRate)) {
              // If the key doesn't exist, set label from predefineArray
              let c = {
                amount: null,
                inputType: "label",
                label: YearWiseCollegeROIData.label,
              };
              graduationvalue.push(c);
            } else {
              Object.keys(GraduationRate).forEach((key) => {
                if (
                  YearWiseCollegeROIData.value == key &&
                  YearWiseCollegeROIData.fieldno == 888888
                ) {
                  if (GraduationRate[key]) {
                    // let costs = this.setValueWithPercentage(
                    //   GraduationRate[key].value
                    // );
                    let c = {
                      amount: GraduationRate[key],

                      inputType: "per",
                    };

                    graduationvalue.push(c);
                  } else {
                    let c = {
                      amount: "-",

                      inputType: "per",
                    };

                    graduationvalue.push(c);
                  }
                } else {
                  if (
                    YearWiseCollegeROIData.value == key &&
                    YearWiseCollegeROIData.fieldno == 1
                  ) {
                    if (GraduationRate[key]?.[10]?.value) {
                      // let costs = this.dollarformat(
                      //   GraduationRate[key]?.[10].value
                      // );
                      let costs = GraduationRate[key]?.[10].value;
                      let c = {
                        amount: costs,

                        inputType: "num",
                      };

                      graduationvalue.push(c);
                    } else {
                      let c = {
                        amount: null,

                        inputType: "num",
                      };

                      graduationvalue.push(c);
                    }
                  }

                  if (
                    YearWiseCollegeROIData?.value == key &&
                    YearWiseCollegeROIData.fieldno == 2
                  ) {
                    let ageOfEarningobj = this.universityList[x]?.dropDownData
                      ?.CollegeWiseProgramList?.programWiseROIData
                      ? this.universityList[x]?.dropDownData
                          ?.CollegeWiseProgramList?.programWiseROIData[0]
                          ?.estEarnings
                      : this.universityList[x]?.dropDownData
                          ?.CollegeWiseProgramList?.programWiseROIData;

                    if (ageOfEarningobj != undefined) {
                      if (ageOfEarningobj.length > 0) {
                        let costs = ageOfEarningobj[0]?.value; // let costs = this.dollarformat(GraduationRate[key]?.[40]?.value);

                        let c = {
                          amount: costs,

                          inputType: "num",
                        };

                        graduationvalue.push(c);
                      } else {
                        let c = {
                          amount: null,

                          inputType: "num",
                        };

                        graduationvalue.push(c);
                      }
                    }
                    //   if (GraduationRate[key]?.[40]?.value) {
                    //   let costs = GraduationRate[key]?.[40]?.value; // let costs = this.dollarformat(GraduationRate[key]?.[40]?.value);

                    //   let c = {
                    //     amount: costs,

                    //     inputType: "num",
                    //   };

                    //   graduationvalue.push(c);
                    // }
                    else {
                      let c = {
                        amount: null,

                        inputType: "num",
                      };

                      graduationvalue.push(c);
                    }
                  }

                  if (
                    YearWiseCollegeROIData.value == key &&
                    YearWiseCollegeROIData.fieldno == 66
                  ) {
                    if (GraduationRate[key]) {
                      let costs = this.setValueWithPercentage(
                        GraduationRate[key]
                      );

                      let c = {
                        amount: costs,

                        inputType: "per",
                      };

                      graduationvalue.push(c);
                    } else {
                      let c = {
                        amount: "-",

                        inputType: "per",
                      };

                      graduationvalue.push(c);
                    }
                  }

                  if (
                    YearWiseCollegeROIData.value == key &&
                    YearWiseCollegeROIData.fieldno == 3
                  ) {
                    if (GraduationRate[key]) {
                      let costs = GraduationRate[key];

                      let c = {
                        amount: costs,

                        inputType: "label",
                      };

                      graduationvalue.push(c);
                    } else {
                      let c = {
                        amount: "-",

                        inputType: "label",
                      };

                      graduationvalue.push(c);
                    }
                  }

                  if (
                    YearWiseCollegeROIData?.value == key &&
                    YearWiseCollegeROIData.fieldno == 777777
                  ) {
                    if (GraduationRate[key]) {
                      // let costs = this.setValueWithPercentage(
                      //   GraduationRate[key]
                      // );

                      let c = {
                        amount: GraduationRate[key],

                        inputType: "per",
                      };

                      graduationvalue.push(c);
                    } else {
                      let c = {
                        amount: "-",

                        inputType: "per",
                      };

                      graduationvalue.push(c);
                    }
                  }
                }
              });
            }
          }
        } else {
          let c = {
            amount: null,
            inputType: "label",
          };
          graduationvalue.push(c);
        }
      }

      meritCostwithLabel = {
        label: YearWiseCollegeROIData.label,

        amount: graduationvalue,

        tooltip: YearWiseCollegeROIData.tooltip,
      };

      meritScholerShipList.push(meritCostwithLabel);
    }

    this.ComparisionMatrixList = meritScholerShipList;
  }

  getValueForField(data: any, fieldno: number) {
    switch (fieldno) {
      case 888888:
        const graduationRateValue = data
          ? this.setValueWithPercentage(data.value)
          : "-";
        return { amount: graduationRateValue, inputType: "per" };

      case 1:
        const costValue = data[10]?.value;
        return {
          amount: costValue !== undefined ? costValue : null,
          inputType: "num",
        };

      case 2:
        const ageOfEarningObj =
          this.universityList?.dropDownData?.CollegeWiseProgramList
            ?.programWiseROIData;
        const earnings =
          ageOfEarningObj && ageOfEarningObj.length > 0
            ? ageOfEarningObj[0]?.value
            : null;
        return {
          amount: earnings !== undefined ? earnings : null,
          inputType: "num",
        };

      case 66:
        const percentageValue = data;
        const percentageCost = percentageValue
          ? this.setValueWithPercentage(percentageValue)
          : "-";
        return { amount: percentageCost, inputType: "per" };

      case 3:
        const labelValue = data;
        return {
          amount: labelValue !== undefined ? labelValue : "-",
          inputType: "label",
        };

      case 777777:
        const customPercentageValue = data;
        const customPercentageCost = customPercentageValue
          ? this.setValueWithPercentage(customPercentageValue)
          : "-";
        return { amount: customPercentageCost, inputType: "per" };

      default:
        return { amount: null, inputType: "label" };
    }
  }

  mailSubmit(mailTo: string) {
    // let userInfoObj = this.codehelp.getLoggedUserDetail();
    // let userInfo = JSON.parse(userInfoObj);
    let StudentList = {
      top5_request: true,
      // user: {
      //   token: this.codehelp.getAuthToken(),
      //   username: userInfo.username,
      //   password: userInfo.password,
      // },
      formfilledId: this.globalvar.formFilledSubmitID,
      SelectCollege: this.studentSelectedCollegeList,
    };
    var encrypted = this.set("govirtue@123", JSON.stringify(StudentList));
    const encrypted_split = encrypted.split("/");
    const ect_string = encrypted_split.join("***");
    let hostname = "";
    if (
      window.location.hostname == "tech.virtueanalytics.com" ||
      window.location.hostname == "localhost"
    ) {
      hostname = "https://tech.virtueanalytics.com/mse2";
    }
    if (window.location.hostname == "app.virtueanalytics.com") {
      hostname = "https://app.virtueanalytics.com/csr";
    }
    //  window.open(hostname + '/top5/home/login/0/' + ect_string, '_blank');
    //  const mailUrl ="https://tech.virtueanalytics.com/mse2/top5/home/login/0/" + ect_string;
    // const mailUrl = hostname + "/top5/home/login/0/" + ect_string;
    const mailUrl = this.globalvar.submissionReportLink;
    this.apiService.sendMail(mailUrl, mailTo).then((resp) => {
      this.notificatioService.showNotification(
        "Mail has been sent successfully.",
        "Send mail",
        true,
        "success"
      );
    });
  }

  sendMail(text: string) {
    this.dialogMailme = this.dialogService.open<any>(
      new PolymorpheusComponent(MailmeComponent, this.injector),
      {
        data: text,
        dismissible: true,
        size: "l",
      }
    );
    this.dialogMailme.subscribe({
      next: (data) => {
        if (data != "") {
          this.mailSubmit(data);
        }
      },
    });
  }

  openInfoMeritRange() {
    this.isOpenMeritInfoRange = !this.isOpenMeritInfoRange;
  }

  dollarformat(val: number) {
    const dollarfirst = val;
    const dollar = dollarfirst.toLocaleString();
    return "$" + " " + dollar;
  }

  private dialogMailme = this.dialogService.open<any>(
    new PolymorpheusComponent(MailmeComponent, this.injector),
    {
      data: {},
      dismissible: true,
      closeable: false,
      label: "",
      size: "s",
    }
  );

  getCollegeWiseProgramList() {
    if (this.desiredStudeyModelValue != "99999") {
      this.collegeWiseProgramList = [];
      let collegeWiseProgram: any = [];
      let collegeCostArray: any = [];
      for (
        let index = 0;
        index < this.predefineArray.collegeWiseProgram.length;
        index++
      ) {
        const collegeProgramValue =
          this.predefineArray.collegeWiseProgram[index];

        let collegeProgramcost = [];
        let collegeProgramcostwithLabel: any = [];
        for (const x in this.universityList) {
          if (
            this.universityList[x]?.dropDownData?.CollegeWiseProgramList
              ?.programCategoryDataPresent == true &&
            this.universityList[x]?.dropDownData?.CollegeWiseProgramList
              ?.programWiseROIData[0] != undefined &&
            this.universityList[x]?.dropDownData?.CollegeWiseProgramList
              ?.programWiseROIData != null
          ) {
            // if (
            //   this.universityList[x]?.dropDownData?.CollegeWiseProgramList
            //     ?.programWiseROIData[0] != undefined && this.universityList[x]?.dropDownData?.CollegeWiseProgramList
            //     ?.programWiseROIData
            // ) {
            let costs = 0;

            let programNameobj =
              this.universityList[x]?.dropDownData?.CollegeWiseProgramList
                ?.programWiseROIData[0];

            if (collegeProgramValue.value == "npvAfterNYears") {
              let ageOfEarningobj = this.universityList[x]?.dropDownData
                ?.CollegeWiseProgramList?.programWiseROIData
                ? this.universityList[x]?.dropDownData?.CollegeWiseProgramList
                    ?.programWiseROIData[0]?.estEarnings
                : this.universityList[x]?.dropDownData?.CollegeWiseProgramList
                    ?.programWiseROIData;

              if (ageOfEarningobj != undefined) {
                if (ageOfEarningobj.length > 0) {
                  let costs = ageOfEarningobj[0]?.value; // let costs = this.dollarformat(GraduationRate[key]?.[40]?.value);
                  let c = {
                    amount: costs > 0 ? costs : 0,
                  };
                  collegeProgramcost.push(c);
                  collegeCostArray = collegeProgramcost;
                } else {
                  let c = {
                    amount: null,
                  };
                  collegeProgramcost.push(c);
                  collegeCostArray = collegeProgramcost;
                }
              } else {
                let c = {
                  amount: null,
                };
                collegeProgramcost.push(c);
                collegeCostArray = collegeProgramcost;
              }
            } else {
              Object.keys(programNameobj).forEach((key, value) => {
                if (collegeProgramValue.value == key) {
                  costs = programNameobj[key];
                  // costs = value;
                  let c = {
                    amount: costs > 0 ? costs : 0,
                  };
                  collegeProgramcost.push(c);

                  collegeCostArray = collegeProgramcost;
                }
              });
            }
          } else {
            let c = {
              amount: 0,
            };

            collegeProgramcost.push(c);
          }
        }
        collegeProgramcostwithLabel = {
          value: collegeProgramValue.value,
          label: collegeProgramValue.label,
          tooltip: collegeProgramValue.tooltip,
          amount: collegeProgramcost,
        };
        collegeWiseProgram.push(collegeProgramcostwithLabel);
      }

      // if (collegeCostArray.length == 5) {
      // if ((collegeCostArray.length >1) && (collegeCostArray.length <= 5)) {
      this.isShowCollegeWiseProgramList = true;
      this.collegeWiseProgramList = collegeWiseProgram;
    }
  }

  getCollegeWiseAgeofEarningList() {
    this.collegeWiseAgeOfEarningList = [];
    let universityList = [];
    let xAxisArr = [];
    let yAxisArr = [];
    for (const x in this.universityList) {
      if (
        this.universityList[x]?.dropDownData?.CollegeWiseProgramList
          ?.programWiseROIData != null
      ) {
        if (
          this.universityList[x]?.dropDownData?.CollegeWiseProgramList
            ?.programWiseROIData[0]?.estEarnings != undefined
        ) {
          xAxisArr = [];
          yAxisArr = [];
          let ageOfEarningobj =
            this.universityList[x]?.dropDownData?.CollegeWiseProgramList
              ?.programWiseROIData[0]?.estEarnings;
          for (let index = 0; index < ageOfEarningobj.length; index++) {
            const ageElement = ageOfEarningobj[index];
            let x = ageElement.range.min + "-" + ageElement.range.max;
            let y = ageElement.value;
            xAxisArr.push(x);
            yAxisArr.push(y);
          }
          let universityData = {
            universityName: this.universityList[x]?.dropDownData.name,
            yAxis: yAxisArr,
          };
          universityList.push(universityData);
        }
      }
    }

    // if (universityList.length > 1 && universityList.length <= 5) {
    // this.isShowCollegeWiseAgeOfEarningList = true;

    let universityChart = {
      xAxis: xAxisArr,
      universityList: universityList,
    };
    // this.collegeWiseAgeOfEarningList.push(universityChart);
    // }
    if (universityChart.xAxis.length > 0) {
      this.isShowCollegeWiseAgeOfEarningList = true;
      this.collegeWiseAgeOfEarningList.push(universityChart);
    } else {
      this.isShowCollegeWiseAgeOfEarningList = false;
    }
  }

  getROIDataForAllCollegeAgeofEarningList(programCategoryId: string) {
    this.collegeWiseAgeOfEarningList = [];
    let isAgeOfEarningDataExits: boolean = false;
    let universityList = [];
    let xAxisArr = [];
    let yAxisArr = [];
    for (const x in this.universityList) {
      if (
        this.universityList[x]?.dropDownData?.ROIDataCollegeWiseAllProgram !=
          undefined &&
        this.universityList[x]?.dropDownData?.ROIDataCollegeWiseAllProgram !=
          null
      ) {
        isAgeOfEarningDataExits = false;
        xAxisArr = [];
        yAxisArr = [];
        let allPrograms =
          this.universityList[x]?.dropDownData?.ROIDataCollegeWiseAllProgram;
        // let ageOfEarningobj =this.universityList[x]?.dropDownData?.ROIDataCollegeWiseAllProgram;

        Object.keys(allPrograms).forEach((key, value) => {
          if (programCategoryId == key) {
            isAgeOfEarningDataExits = true;
            let ageOfEarningobj = allPrograms[key];
            for (
              let index = 0;
              index < ageOfEarningobj[0].estEarnings.length;
              index++
            ) {
              const ageElement = ageOfEarningobj[0].estEarnings[index];
              let x = ageElement.range.min + "-" + ageElement.range.max;
              let y = ageElement.value;
              xAxisArr.push(x);
              yAxisArr.push(y);
            }
          }
        });
        if (isAgeOfEarningDataExits != false) {
          let universityData = {
            universityName: this.universityList[x]?.dropDownData.name,
            yAxis: yAxisArr,
          };
          universityList.push(universityData);
        }
      }
    }

    // if (universityList.length > 1 && universityList.length <= 5) {

    let universityChart = {
      xAxis: xAxisArr,
      universityList: universityList,
    };

    if (universityChart.xAxis.length > 0) {
      this.isShowCollegeWiseAgeOfEarningList = true;
      this.collegeWiseAgeOfEarningList.push(universityChart);
    } else {
      this.isShowCollegeWiseAgeOfEarningList = false;
    }
    // }
  }
  getCollegeWise4YearTotalExpensesList() {
    this.collegeWise4YearTotalExpensesLifeTimeList = [];
    let universityList = [];
    let universityNameList = [];
    let xAxisArr = [];
    let yAxislifetimeROI = [];
    let yAxisfourYearTotalExpenditure = [];
    for (const x in this.universityList) {
      if (
        this.universityList[x]?.dropDownData?.CollegeWiseProgramList
          ?.fourYearTotalExpenditure != undefined &&
        this.universityList[x]?.dropDownData?.CollegeWiseProgramList
          ?.programWiseROIData[0]?.lifetimeROI != undefined
      ) {
        this.isShowcollegeWise4YearTotalExpensesLifeTimeList = true;
        let lifetimeROIobj =
          this.universityList[x]?.dropDownData?.CollegeWiseProgramList
            ?.programWiseROIData[0]?.lifetimeROI;
        let FourYearEarningobj =
          this.universityList[x]?.dropDownData?.CollegeWiseProgramList
            ?.fourYearTotalExpenditure;

        xAxisArr.push(this.universityList[x]?.dropDownData.name);
        yAxislifetimeROI.push(lifetimeROIobj);
        yAxisfourYearTotalExpenditure.push(FourYearEarningobj);

        let universityName = {
          universityName: this.universityList[x]?.dropDownData.name,
        };
        universityNameList.push(universityName);
      }
    }
    if (
      yAxislifetimeROI.length > 0 &&
      yAxisfourYearTotalExpenditure.length > 0
    ) {
      let universityData = {
        universityName: universityNameList,
        yAxislifetimeROI: yAxislifetimeROI,
        yAxis4YearTotalExpenditure: yAxisfourYearTotalExpenditure,
      };
      universityList.push(universityData);
    }
    let universityChart = {
      xAxis: xAxisArr,
      universityList: universityList,
    };
    this.collegeWise4YearTotalExpensesLifeTimeList.push(universityChart);
  }

  getMeritScholarshipDataList() {
    for (const x in this.universityList) {
      this.result = {};
      if (this.universityList[x]?.dropDownData?.result != undefined) {
        this.result = this.universityList[x]?.dropDownData["result"];
      }
    }
  }

  getIpedsCostOfAttendance() {
    this.costOfAttendanceData = [];

    for (const x in this.universityList) {
      if (
        this.universityList[x].dropDownData["costOfAttendance"] != undefined
      ) {
        this.costOfAttendanceData[x] =
          this.universityList[x].dropDownData["costOfAttendance"];
      }
    }
  }

  getNPCCostOfAttendanceData() {
    this.costOfAttendanceData = [];
    let costOfAttendanceList: any = [];
    this.costOfAttendanceFilterAmount = [];
    this.costOfAttendanceData = [];

    for (
      let index = 0;
      index < this.predefineArray.feesBreakDownKeysLabel.length;
      index++
    ) {
      const breakdownCost = this.predefineArray.feesBreakDownKeysLabel[index];
      let breakCost = [];
      let costwithLabel: any = [];

      for (const x in this.universityList) {
        if (
          this.universityList[x].dropDownData["npcCollegeCostProfile"].length >
            0 &&
          this.universityList[x].dropDownData["npcCollegeCostProfile"] !=
            undefined
        ) {
          let breakDownCosts =
            this.universityList[x].dropDownData["npcCollegeCostProfile"];
          let applicable = false;
          let tooltip = "";
          let url = "";
          let name = "";
          if (
            this.universityList[x].dropDownData?.result?.reciprocityGrant
              ?.applicable != undefined &&
            breakdownCost.fieldNo == "49"
          ) {
            let objapplicable =
              this.universityList[x].dropDownData["result"]?.reciprocityGrant;
            applicable =
              this.universityList[x].dropDownData["result"]?.reciprocityGrant
                ?.applicable;
            tooltip = breakdownCost.tooltip;
            if (objapplicable?.eligibleAlliances.length > 0) {
              url = objapplicable?.eligibleAlliances[0]?.url;
              name = objapplicable?.eligibleAlliances[0]?.name;
            }
          }
          let costs = 0;

          Object.keys(breakDownCosts).forEach((key) => {
            if (breakdownCost.fieldNo == breakDownCosts[key].fieldNo) {
              costs = breakDownCosts[key].value;
              let c = {
                amount: costs,
                collegeName: this.universityList[x]?.dropDownData.name,
                reciprocityGrant: applicable,
                url: url,
                name: name,
              };
              breakCost.push(c);
            }
          });

          costwithLabel = {
            label: breakdownCost.label,
            reciprocityGrant: applicable,
            tooltip: breakdownCost.tooltip,
            amount: breakCost,
          };
        } else {
          let c = {
            amount: 0,
            collegeName: "",
            reciprocityGrant: "",
            url: "",
            name: "",
          };
          breakCost.push(c);
          costwithLabel = {
            label: breakdownCost.label,
            reciprocityGrant: false,
            tooltip: "",
            amount: breakCost,
          };
        }
      }
      costOfAttendanceList.push(costwithLabel);
    }
    this.costOfAttendanceData = costOfAttendanceList;
  }
  getIpedsCostOfAttendanceData() {
    this.costOfAttendanceData = [];
    let costOfAttendanceList: any = [];
    this.costOfAttendanceFilterAmount = [];

    this.costOfAttendanceData = [];

    for (
      let index = 0;
      index < this.predefineArray.feesBreakDownKeysLabel.length;
      index++
    ) {
      const breakdownCost = this.predefineArray.feesBreakDownKeysLabel[index];
      let breakCost = [];
      let costwithLabel: any = [];

      for (const x in this.universityList) {
        let breakDownCosts = [];
        if (!this.showOcrData[x]) {
          breakDownCosts = this.calculateIpedsNPCCOA(x);
        }
        // if (this.isShowNPCData[index]==true) {
        //   if (
        //     this.universityList[x].dropDownData["npcCollegeCostProfile"]
        //       .length > 0 &&
        //     this.universityList[x].dropDownData["npcCollegeCostProfile"] !=
        //       undefined
        //   ) {
        //     breakDownCosts =
        //       this.universityList[x].dropDownData["npcCollegeCostProfile"];
        //   }
        // }
        // else{
        //   if (this.isIPEDSToggle == true) {
        //     if (
        //       this.universityList[x].dropDownData["costOfAttendance"].length >
        //         0 &&
        //       this.universityList[x].dropDownData["costOfAttendance"] != undefined
        //     ) {
        //       breakDownCosts =
        //         this.universityList[x].dropDownData["costOfAttendance"];
        //     }
        //   } else {
        //     if (
        //       this.universityList[x].dropDownData["npcCollegeCostProfile"]
        //         .length > 0 &&
        //       this.universityList[x].dropDownData["npcCollegeCostProfile"] !=
        //         undefined
        //     ) {
        //       breakDownCosts =
        //         this.universityList[x].dropDownData["npcCollegeCostProfile"];
        //     }
        //   }
        // }

        if (breakDownCosts.length) {
          //  let breakDownCosts = this.universityList[x].dropDownData["costOfAttendance"];
          let applicable = false;
          let tooltip = "";
          let url = "";
          let name = "";
          if (
            this.universityList[x].dropDownData?.result?.reciprocityGrant
              ?.applicable != undefined &&
            breakdownCost.fieldNo == "49"
          ) {
            let objapplicable =
              this.universityList[x].dropDownData["result"]?.reciprocityGrant;
            applicable =
              this.universityList[x].dropDownData["result"]?.reciprocityGrant
                ?.applicable;
            tooltip = breakdownCost.tooltip;
            if (objapplicable?.eligibleAlliances.length > 0) {
              url = objapplicable?.eligibleAlliances[0]?.url;
              name = objapplicable?.eligibleAlliances[0]?.name;
            }
          }
          let costs = 0;
          let errorInCollegeCost = false;
          Object.keys(breakDownCosts).forEach((key) => {
            if (breakdownCost.fieldNo == breakDownCosts[key].fieldNo) {
              costs = breakDownCosts[key].value;
              if (this.isIPEDSToggle == false) {
                errorInCollegeCost =
                  breakDownCosts[key]?.differenceInCosts?.errorInCollegeCost;
              }
              let c = {
                amount: costs,
                collegeName: this.universityList[x]?.dropDownData.name,
                reciprocityGrant: applicable,
                errorInCollegeCost: errorInCollegeCost,
                errorInCollegetooltip:
                  "We have identified some discrepancies in the reported costs for this college.",
                // errorInCollegetooltip:"We recommend to get in touch with the college for exact costs.",
                url: url,
                name: name,
              };
              breakCost.push(c);
            }
          });

          costwithLabel = {
            label: breakdownCost.label,
            reciprocityGrant: applicable,
            tooltip: breakdownCost.tooltip,
            amount: breakCost,
          };
        } else {
          let c = {
            amount: 0,
            collegeName: "",
            reciprocityGrant: "",
            errorInCollegeCost: false,
            errorInCollegetooltip: "",
            url: "",
            name: "",
          };
          breakCost.push(c);
          costwithLabel = {
            label: breakdownCost.label,
            reciprocityGrant: false,
            errorInCollegeCost: false,
            errorInCollegetooltip: "",
            tooltip: "",
            amount: breakCost,
          };
        }
      }
      costOfAttendanceList.push(costwithLabel);
    }
    this.costOfAttendanceData = costOfAttendanceList;
  }

  calculateIpedsNPCCOA(x: string) {
    let breakDownCosts = [];
    if (this.isShowNPCData[x] == true) {
      if (this.isIPEDSToggle == true) {
        if (
          this.universityList[x].dropDownData["costOfAttendance"].length > 0 &&
          this.universityList[x].dropDownData["costOfAttendance"] != undefined
        ) {
          breakDownCosts =
            this.universityList[x]?.dropDownData["costOfAttendance"];
        }
      } else {
        if (
          this.universityList[x].dropDownData["npcCollegeCostProfile"].length >
            0 &&
          this.universityList[x].dropDownData["npcCollegeCostProfile"] !=
            undefined
        ) {
          breakDownCosts =
            this.universityList[x]?.dropDownData["npcCollegeCostProfile"];
        }
      }
    } else {
      if (this.isIPEDSToggle == true) {
        if (
          this.universityList[x].dropDownData["costOfAttendance"].length > 0 &&
          this.universityList[x].dropDownData["costOfAttendance"] != undefined
        ) {
          breakDownCosts =
            this.universityList[x].dropDownData["costOfAttendance"];
        }
      } else {
        if (
          this.universityList[x].dropDownData["npcCollegeCostProfile"].length >
            0 &&
          this.universityList[x].dropDownData["npcCollegeCostProfile"] !=
            undefined
        ) {
          breakDownCosts =
            this.universityList[x].dropDownData["npcCollegeCostProfile"];
        }
      }
    }

    return breakDownCosts;
  }

  // Code from Ravi

  // getInstGrantData() {
  //   this.meritScholerShipData = [];
  //   let meritScholerShipList: any = [];

  //   let InstGrantList = [];
  //   if (this.globalvar.isInternatinalStudent) {
  //     InstGrantList.push(this.predefineArray.institutionalAid[0]);
  //   } else {
  //     InstGrantList = this.predefineArray.institutionalAid;
  //   }

  //   if (this.globalvar.isInternatinalStudent == true) {
  //     InstGrantList.splice(1, 1);
  //   }
  //   for (let index = 0; index < InstGrantList.length; index++) {
  //     const institutionalAid = InstGrantList[index];

  //     let meritCost = [];
  //     let meritCostwithLabel: any = [];
  //     let neighbouringMeritBasedAids = [];
  //     let isMeritRangeInfo: boolean = false;
  //     let outStateGridNotUsed: boolean = false;

  //     for (const x in this.universityList) {
  //       if (this.showOcrData[x] == false) {
  //         if (
  //           this.universityList[x].dropDownData?.result?.institutionalGrants !=
  //           undefined
  //         ) {
  //           let preferOutStateGrid: boolean = false;
  //           if (
  //             this.universityList[x].dropDownData?.result?.preferOutStateGrid !=
  //             undefined
  //           ) {
  //             preferOutStateGrid =
  //               this.universityList[x].dropDownData?.result?.preferOutStateGrid;
  //           }

  //           let costs = 0;
  //           let meritName =
  //             this.universityList[x].dropDownData?.result?.institutionalGrants;

  //           if (
  //             this.universityList[x].dropDownData?.result?.institutionalGrants
  //               ?.neighbouringMeritBasedAids?.length > 0
  //           ) {
  //             neighbouringMeritBasedAids =
  //               this.universityList[x].dropDownData?.result?.institutionalGrants
  //                 ?.neighbouringMeritBasedAids;
  //           }
  //           Object.keys(meritName).forEach((key) => {
  //             if (institutionalAid.name == key) {
  //               costs = meritName[key].amount;
  //               // if (meritName[key]?.outStateGridUsed != undefined) {
  //               //   outStateGridNotUsed =costs > 0 && meritName[key]?.outStateGridUsed == false && preferOutStateGrid == true? true: false;

  //               // }
  //               let c = {
  //                 amount: costs,
  //                 outStateGridNotUsed: outStateGridNotUsed,
  //                 outStateGridNotUsedToolTip:
  //                   "The grants for this college are calculated using  grant data for in-state students, actual grants may vary.",
  //                 meritRange: neighbouringMeritBasedAids,
  //               };
  //               if (costs && neighbouringMeritBasedAids.length > 0) {
  //                 isMeritRangeInfo = true;
  //               }
  //               meritCost.push(c);
  //             }
  //           });
  //         } else {
  //           let c = {
  //             amount: 0,
  //             meritRange: 0,
  //             outStateGridNotUsedToolTip: "",
  //             outStateGridNotUsed: false,
  //           };
  //           meritCost.push(c);
  //         }
  //       } else {
  //         let c = {
  //           amount: 0,
  //           meritRange: 0,
  //           outStateGridNotUsedToolTip: "",
  //           outStateGridNotUsed: false,
  //         };
  //         meritCost.push(c);
  //       }
  //     }
  //     meritCostwithLabel = {
  //       label: institutionalAid.label,
  //       isMeritRangeInfo: isMeritRangeInfo,
  //       name: institutionalAid.name,
  //       amount: meritCost,
  //     };
  //     meritScholerShipList.push(meritCostwithLabel);
  //   }
  //   this.meritScholerShipData = meritScholerShipList;
  // }
  // getInstGrantData() {
  //   this.meritScholerShipData = [];
  //   let meritScholerShipList: any = [];

  //   let InstGrantList = [];
  //   if (this.globalvar.isInternatinalStudent) {
  //     InstGrantList.push(this.predefineArray.institutionalAid[0]);
  //   } else {
  //     InstGrantList = this.predefineArray.institutionalAid;
  //   }

  //   if (this.globalvar.isInternatinalStudent == true) {
  //     InstGrantList.splice(1, 1);
  //   }

  //   for (let index = 0; index < InstGrantList.length; index++) {
  //     const institutionalAid = InstGrantList[index];

  //     let meritCost = [];
  //     let meritCostwithLabel: any = {};
  //     let isMeritRangeInfo: boolean = false;

  //     for (const x in this.universityList) {
  //       if (this.showOcrData[x] == false) {
  //         if (
  //           this.universityList[x].dropDownData?.result?.institutionalGrants !=
  //           undefined
  //         ) {
  //           let preferOutStateGrid: boolean = false;
  //           if (
  //             this.universityList[x].dropDownData?.result?.preferOutStateGrid !=
  //             undefined
  //           ) {
  //             preferOutStateGrid =
  //               this.universityList[x].dropDownData?.result?.preferOutStateGrid;
  //           }

  //           let costs = 0;
  //           let meritName =
  //             this.universityList[x].dropDownData?.result?.institutionalGrants;

  //           let neighbouringMeritBasedAidsAsPerAct = [];
  //           let neighbouringMeritBasedAidsAsPerGpa = [];

  //           if (
  //             this.universityList[x].dropDownData?.result?.institutionalGrants
  //               ?.neighbouringMeritBasedAidsAsPerAct?.length > 0
  //           ) {
  //             neighbouringMeritBasedAidsAsPerAct =
  //               this.universityList[x].dropDownData?.result?.institutionalGrants
  //                 ?.neighbouringMeritBasedAidsAsPerAct;
  //           }

  //           if (
  //             this.universityList[x].dropDownData?.result?.institutionalGrants
  //               ?.neighbouringMeritBasedAidsAsPerGpa?.length > 0
  //           ) {
  //             neighbouringMeritBasedAidsAsPerGpa =
  //               this.universityList[x].dropDownData?.result?.institutionalGrants
  //                 ?.neighbouringMeritBasedAidsAsPerGpa;
  //           }

  //           Object.keys(meritName).forEach((key) => {
  //             if (institutionalAid.name == key) {
  //               costs = meritName[key].amount;

  //               let c = {
  //                 amount: costs,
  //                 outStateGridNotUsedToolTip:
  //                   "The grants for this college are calculated using grant data for in-state students, actual grants may vary.",
  //                 act: this.getActFromNeighbouringMerit(
  //                   neighbouringMeritBasedAidsAsPerAct
  //                 ),
  //                 gpa: this.getGpaFromNeighbouringMerit(
  //                   neighbouringMeritBasedAidsAsPerGpa
  //                 ),
  //               };

  //               if (costs && (neighbouringMeritBasedAidsAsPerAct.length > 0 || neighbouringMeritBasedAidsAsPerGpa.length > 0)) {
  //                 isMeritRangeInfo = true;
  //               }
  //               meritCost.push(c);
  //             }
  //           });
  //         } else {
  //           let c = {
  //             amount: 0,
  //             outStateGridNotUsedToolTip: "",
  //           };
  //           meritCost.push(c);
  //         }
  //       } else {
  //         let c = {
  //           amount: 0,
  //           outStateGridNotUsedToolTip: "",
  //         };
  //         meritCost.push(c);
  //       }
  //     }

  //     meritCostwithLabel[institutionalAid.name] = {
  //       label: institutionalAid.label,
  //       isMeritRangeInfo: isMeritRangeInfo,
  //       name: institutionalAid.name,
  //       amount: meritCost,
  //     };

  //     meritScholerShipList.push(meritCostwithLabel);
  //   }

  //   console.log(meritScholerShipList, "MeritScholarship");
  //   this.meritScholerShipData = meritScholerShipList;
  // }

  getInstGrantData() {
    this.meritScholerShipData = [];
    let meritScholerShipList: any = [];

    let InstGrantList = [];
    if (this.globalvar.isInternatinalStudent) {
      InstGrantList.push(this.predefineArray.institutionalAid[0]);
    } else {
      InstGrantList = this.predefineArray.institutionalAid;
    }

    if (this.globalvar.isInternatinalStudent == true) {
      InstGrantList.splice(1, 1);
    }
    for (let index = 0; index < InstGrantList.length; index++) {
      const institutionalAid = InstGrantList[index];

      let meritCost = [];
      let meritCostwithLabel: any = [];
      let neighbouringMeritBasedAidsAsPerAct = [];
      let neighbouringMeritBasedAidsAsPerGpa = [];
      let isMeritRangeInfo: boolean = false;
      let outStateGridNotUsed: boolean = false;

      for (const x in this.universityList) {
        if (this.showOcrData[x] == false) {
          if (
            this.universityList[x].dropDownData?.result?.institutionalGrants !=
            undefined
          ) {
            let preferOutStateGrid: boolean = false;
            if (
              this.universityList[x].dropDownData?.result?.preferOutStateGrid !=
              undefined
            ) {
              preferOutStateGrid =
                this.universityList[x].dropDownData?.result?.preferOutStateGrid;
            }

            let costs = 0;
            let meritName =
              this.universityList[x].dropDownData?.result?.institutionalGrants;

            if (
              this.universityList[x].dropDownData?.result?.institutionalGrants
                ?.neighbouringMeritBasedAidsAsPerAct?.length > 0
            ) {
              neighbouringMeritBasedAidsAsPerAct =
                this.universityList[x].dropDownData?.result?.institutionalGrants
                  ?.neighbouringMeritBasedAidsAsPerAct;
            }

            if (
              this.universityList[x].dropDownData?.result?.institutionalGrants
                ?.neighbouringMeritBasedAidsAsPerGpa?.length > 0
            ) {
              neighbouringMeritBasedAidsAsPerGpa =
                this.universityList[x].dropDownData?.result?.institutionalGrants
                  ?.neighbouringMeritBasedAidsAsPerGpa;
            }

            Object.keys(meritName).forEach((key) => {
              if (institutionalAid.name == key) {
                costs = meritName[key].amount;
                // if (meritName[key]?.outStateGridUsed != undefined) {
                //   outStateGridNotUsed =costs > 0 && meritName[key]?.outStateGridUsed == false && preferOutStateGrid == true? true: false;

                // }
                let c = {
                  amount: costs,
                  outStateGridNotUsed: outStateGridNotUsed,
                  outStateGridNotUsedToolTip:
                    "The grants for this college are calculated using grant data for in-state students, actual grants may vary.",
                  // meritRange: neighbouringMeritBasedAidsAsPerAct,
                  meritRange: {
                    act: this.getActFromNeighbouringMerit(
                      neighbouringMeritBasedAidsAsPerAct
                    ),
                    gpa: this.getGpaFromNeighbouringMerit(
                      neighbouringMeritBasedAidsAsPerGpa
                    ),
                  },
                };

                if (
                  neighbouringMeritBasedAidsAsPerAct.length > 0 ||
                  neighbouringMeritBasedAidsAsPerGpa.length > 0
                ) {
                  isMeritRangeInfo = true;
                }
                meritCost.push(c);
              }
            });
          } else {
            let c = {
              amount: 0,
              meritRange: 0,
              outStateGridNotUsedToolTip: "",
              outStateGridNotUsed: false,
            };
            meritCost.push(c);
          }
        } else {
          let c = {
            amount: 0,
            meritRange: 0,
            outStateGridNotUsedToolTip: "",
            outStateGridNotUsed: false,
          };
          meritCost.push(c);
        }
      }
      meritCostwithLabel = {
        label: institutionalAid.label,
        isMeritRangeInfo: isMeritRangeInfo,
        name: institutionalAid.name,
        amount: meritCost,
      };
      meritScholerShipList.push(meritCostwithLabel);
    }
    console.log(meritScholerShipList, "MeritScholarship");
    this.meritScholerShipData = meritScholerShipList;
  }
  getActFromNeighbouringMerit(
    neighbouringMeritBasedAidsAsPerAct: any[]
  ): { act: number; amount: number }[] | null {
    // Extract 'act' and 'amount' properties from each item in the array
    const actsWithAmount = neighbouringMeritBasedAidsAsPerAct.map((item) => ({
      act: item.act,
      amount: item.amount,
    }));

    return actsWithAmount.length > 0 ? actsWithAmount : null;
  }

  getGpaFromNeighbouringMerit(
    neighbouringMeritBasedAidsAsPerGpa: any[]
  ): { gpa: number; amount: number }[] | null {
    // Extract 'act' and 'amount' properties from each item in the array
    const gpasWithAmount = neighbouringMeritBasedAidsAsPerGpa.map((item) => ({
      gpa: item.gpa,
      amount: item.amount,
    }));

    return gpasWithAmount.length > 0 ? gpasWithAmount : null;
  }

  // getActFromNeighbouringMerit(
  //   neighbouringMeritBasedAidsAsPerAct: any[]
  // ): number | null {
  //   // Implement your logic to get the 'act' property from the array
  //   // For example, you can return the 'act' from the first item in the array
  //   return neighbouringMeritBasedAidsAsPerAct.length > 0
  //     ? neighbouringMeritBasedAidsAsPerAct[0].act
  //     : null;
  // }

  // getGpaFromNeighbouringMerit(

  //   neighbouringMeritBasedAidsAsPerGpa: any[]
  // ): number | null {
  //   debugger
  //   // Implement your logic to get the 'gpa' property from the array
  //   // For example, you can return the 'gpa' from the first item in the array
  //   return neighbouringMeritBasedAidsAsPerGpa.length > 0
  //     ? neighbouringMeritBasedAidsAsPerGpa[0].gpa
  //     : null;
  // }

  getFederalAidData() {
    this.federalAidData = [];
    let federalAidCostList: any = [];
    for (
      let index = 0;
      index < this.predefineArray.collegeFederalAid.length;
      index++
    ) {
      const institutionalAid = this.predefineArray.collegeFederalAid[index];

      let federalAidCost = [];
      let federalAidwithLabel: any = [];
      for (const x in this.universityList) {
        if (this.showOcrData[x] == false) {
          if (
            this.universityList[x].dropDownData?.result?.federalAid != undefined
          ) {
            //   let costs = 0;
            let federalAidName =
              this.universityList[x].dropDownData["result"].federalAid;
            let selectedStateCode =
              this.universityList[x]?.dropDownData?.StudentSelectedCollege;
            let cssProfileEFC =
              this.universityList[x]?.summaryData?.cssProfileEFC;

            Object.keys(federalAidName).forEach((key) => {
              if (institutionalAid.name == key) {
                // costs = federalAidName[key].amount;
                let costs = this.setStateFederalIncludedAndEligibalAmount1(
                  federalAidName[key],
                  cssProfileEFC
                );
                let c = {
                  amount: costs,
                };
                federalAidCost.push(c);
              }
            });
          } else {
            let c = {
              amount: 0,
            };
            federalAidCost.push(c);
          }
        } else {
          let c = {
            amount: 0,
          };
          federalAidCost.push(c);
        }
      }
      federalAidwithLabel = {
        label: institutionalAid.label,
        amount: federalAidCost,
      };
      federalAidCostList.push(federalAidwithLabel);
    }
    this.federalAidData = federalAidCostList;
  }

  setStateFederalIncludedAndEligibalAmount1(
    obj: FederalAndState,
    cssProfileEFC: Number
  ) {
    // let collegeWiseStateCode =selectedState?.stateCode!=undefined?selectedState?.stateCode:'';
    let EFC: Number = 0;
    let profileEFC = this.answerMap.get(40);

    if (cssProfileEFC) {
      EFC = cssProfileEFC;
    } else {
      if (profileEFC) {
        EFC = Number(profileEFC.value);
      }
    }
    if (obj.isIncluded == true) {
      if (Number(EFC) > 6657 || Number(EFC) > 6656) {
        return "Ineligible";
      } else {
        return "Included";
      }
    } else if (obj?.amount) {
      return obj?.amount == -1 ? "-" : obj?.amount;
    } else if (obj.isEligible == true) {
      // if ((studentState.value.toLowerCase() != "mn") && (collegeWiseStateCode.toLowerCase()==studentState.value.toLowerCase())) {
      //   return statGrand.value;
      // } else {
      return "Eligible";
      // }
    } else {
      return "Ineligible";
    }
  }

  setStateAidandGrandAmount(obj: FederalAndState, selectedState: any) {
    let statGrand = this.answerMap.get(99999);
    let studentState = this.answerMap.get(6);
    let collegeWiseStateCode =
      selectedState?.stateCode != undefined ? selectedState?.stateCode : "";
    //  if (obj.amount) {
    //   return obj.amount;
    // } else
    // studentState.value.toLowerCase() != "mn" &&
    // studentState.value.toLowerCase() != "nj" &&
    let collegeWiseStateGrant =
      selectedState?.universityWiseStateGrant.length > 0
        ? selectedState?.universityWiseStateGrant[0]?.amount
        : 0;
    if (obj.isEligible == true && obj.isIncluded != true) {
      if (collegeWiseStateGrant) {
        return collegeWiseStateGrant;
      } else if (
        this.checkStateCalculatorExist(studentState.value) == false &&
        collegeWiseStateCode.toLowerCase() == studentState.value.toLowerCase()
      ) {
        return statGrand != undefined ? statGrand.value : 0;
      } else {
        return 0;
      }
    } else {
      return 0;
    }
  }

  setStateIncludedAndEligibalAmount(
    obj: FederalAndState,
    selectedState: any,
    cssProfileEFC: Number
  ) {
    let statGrand = this.answerMap.get(99999);
    let studentState = this.answerMap.get(6);
    let collegeWiseStateCode =
      selectedState?.stateCode != undefined ? selectedState?.stateCode : "";

    let collegeWiseStateGrant =
      selectedState?.universityWiseStateGrant.length > 0
        ? selectedState?.universityWiseStateGrant[0]?.amount
        : 0;
    let EFC: Number = 0;
    let profileEFC = this.answerMap.get(40);

    if (cssProfileEFC) {
      EFC = cssProfileEFC;
    } else {
      if (profileEFC) {
        EFC = Number(profileEFC.value);
      }
    }
    if (obj.isIncluded == true) {
      let checkList = this.predefineArray.studentProfileStateCodeInstate.some(
        (el) => el.value == selectedState?.domicileAndResidency
      );
      if (!checkList) {
        return "Ineligible";
      } else {
        return "Included";
      }
    } else if (obj?.amount) {
      return obj?.amount == -1 ? "-" : obj.amount;
    } else if (obj.isEligible == true) {
      if (collegeWiseStateGrant) {
        return collegeWiseStateGrant;
      } else if (
        statGrand != undefined &&
        this.checkStateCalculatorExist(studentState.value) == false &&
        collegeWiseStateCode.toLowerCase() == studentState.value.toLowerCase()
      ) {
        return statGrand.value;
      } else {
        return "Eligible";
      }
    } else {
      return "Ineligible";
    }
  }

  setStateFederalIncludedAndEligibalAmount(
    obj: FederalAndState,
    selectedState: any,
    cssProfileEFC: Number
  ) {
    // studentState.value.toLowerCase() != "mn" &&
    // studentState.value.toLowerCase() != "nj" &&
    let statGrand = this.answerMap.get(99999);
    let studentState = this.answerMap.get(6);
    let collegeWiseStateCode =
      selectedState?.stateCode != undefined ? selectedState?.stateCode : "";

    let collegeWiseStateGrant =
      selectedState?.universityWiseStateGrant.length > 0
        ? selectedState?.universityWiseStateGrant[0]?.amount
        : 0;

    let EFC: Number = 0;
    let profileEFC = this.answerMap.get(40);

    if (cssProfileEFC) {
      EFC = cssProfileEFC;
    } else {
      if (profileEFC) {
        EFC = Number(profileEFC.value);
      }
    }
    if (obj.isIncluded == true) {
      if (Number(EFC) > 6657 || Number(EFC) > 6656) {
        return "ineligible";
      } else {
        return "Included";
      }
    } else if (obj?.amount) {
      return obj?.amount == -1 ? "-" : obj.amount;
    } else if (obj.isEligible == true) {
      if (collegeWiseStateGrant) {
        return collegeWiseStateGrant;
      } else if (
        statGrand != undefined &&
        this.checkStateCalculatorExist(studentState.value) == false &&
        collegeWiseStateCode.toLowerCase() == studentState.value.toLowerCase()
      ) {
        return statGrand.value;
      } else {
        return "Eligible";
      }
    } else {
      return "Ineligible";
    }
  }

  getStateAidData() {
    this.StateAidData = [];
    let stateGrantCostList: any = [];
    for (
      let index = 0;
      index < this.predefineArray.stateGrantList.length;
      index++
    ) {
      const stateGrant = this.predefineArray.stateGrantList[index];

      let stateGrantCost = [];
      let stateGrantwithLabel: any = [];
      for (const x in this.universityList) {
        if (this.showOcrData[x] == false) {
          if (
            this.universityList[x].dropDownData?.result?.federalAid != undefined
          ) {
            //let costs = 0;
            let stateGrantData =
              this.universityList[x].dropDownData["result"].stateAid;
            let selectedStateCode =
              this.universityList[x]?.dropDownData?.StudentSelectedCollege;
            let cssProfileEFC =
              this.universityList[x]?.summaryData?.cssProfileEFC;
            // Object.keys(stateGrantData).forEach((key) => {
            // if(stateGrant.name==key)
            // {
            // let  costs = stateGrantData.amount;
            let costs = this.setStateIncludedAndEligibalAmount(
              stateGrantData,
              selectedStateCode,
              cssProfileEFC
            );
            let c = {
              amount: costs,
            };
            stateGrantCost.push(c);
            // }
            // });
          } else {
            let c = {
              amount: 0,
            };
            stateGrantCost.push(c);
          }
        } else {
          let c = {
            amount: 0,
          };
          stateGrantCost.push(c);
        }
      }
      stateGrantwithLabel = {
        label: stateGrant.label,
        amount: stateGrantCost,
      };
      stateGrantCostList.push(stateGrantwithLabel);
    }
    this.StateAidData = stateGrantCostList;
  }

  getbasedOnCollegeWebsiteAmount(clg: any) {
    let totalGrant = 0;
    let npcCOAAmt = 0;
    let basedOnCollegeWebsiteAmount = 0;

    if (
      clg?.dropDownData["result"]?.totalGrant?.amount ||
      clg?.summaryData?.basedOnCollegeWebsite
    ) {
      // console.log("college",clg)
      // console.log("result",clg?.dropDownData["result"]?.totalGrant?.amount)
      // console.log("basedOnCollegeWebsite",clg?.summaryData?.basedOnCollegeWebsite)
      totalGrant =
        clg?.dropDownData["result"]?.totalGrant?.amount != undefined
          ? clg?.dropDownData["result"]?.totalGrant?.amount
          : 0;
      npcCOAAmt = clg?.summaryData?.basedOnCollegeWebsite
        ? clg?.summaryData?.basedOnCollegeWebsite
        : 0;
    }

    let affinityAmt = this.getAffinityAmount(
      clg?.dropDownData.yearWiseAffinityQuestion
    );
    if (affinityAmt) {
      totalGrant += affinityAmt;
    }

    let stateGrantData = clg?.dropDownData["result"]?.stateAid;
    let selectedStateCode = clg?.dropDownData?.StudentSelectedCollege;

    if (stateGrantData != undefined) {
      let grntAmt = Number(
        this.setStateAidandGrandAmount(stateGrantData, selectedStateCode)
      );
      totalGrant += grntAmt;
    }

    if ((npcCOAAmt || totalGrant) && npcCOAAmt > totalGrant) {
      basedOnCollegeWebsiteAmount = npcCOAAmt - totalGrant;
      // this.roundOfNumber(npcCOAAmt) - this.roundOfNumber(totalGrant);
    }
    return basedOnCollegeWebsiteAmount > 0 ? basedOnCollegeWebsiteAmount : 0;
  }

  getbasedOnAwardLetterAmount(clg: any) {
    let totalGrant = 0;
    let OCRCOAAmt = 0;
    let basedOnAwardLetterAmount = 0;

    if (clg?.ocrDataCoaSum || clg?.ocrDataScholarshipsSum) {
      totalGrant =
        clg?.ocrDataScholarshipsSum != undefined
          ? clg?.ocrDataScholarshipsSum
          : 0;
      OCRCOAAmt = clg?.ocrDataCoaSum ? clg?.ocrDataCoaSum : 0;
    }

    if ((OCRCOAAmt || totalGrant) && OCRCOAAmt > totalGrant) {
      // basedOnAwardLetterAmount = OCRCOAAmt - totalGrant;
      basedOnAwardLetterAmount = OCRCOAAmt - totalGrant;
      // this.roundOfNumber(OCRCOAAmt) - this.roundOfNumber(totalGrant);
    }
    return basedOnAwardLetterAmount > 0 ? basedOnAwardLetterAmount : 0;
  }

  changeView() {
    this.isCartView = !this.isCartView;

    if (!this.isCartView) {
      // this.getSortbyCollege();
      this.getCollegeData();
    }
  }

  getOutOfPocketAmount(item: any, i: number) {
    let costOfAttendanceAmount = 0;
    let AffinityAmount = 0;
    let meritScholarShipAmt = 0;
    let costofAttendanceList = [];

    if (this.isShowNPCData[i] == true) {
      if (this.isIPEDSToggle == true) {
        if (item?.dropDownData["costOfAttendance"]) {
          costofAttendanceList = item?.dropDownData["costOfAttendance"];
        }
      } else {
        if (item?.dropDownData["npcCollegeCostProfile"]) {
          costofAttendanceList = item?.dropDownData["npcCollegeCostProfile"];
        }
      }
    } else {
      if (this.isIPEDSToggle == true) {
        if (item?.dropDownData["costOfAttendance"]) {
          costofAttendanceList = item?.dropDownData["costOfAttendance"];
        }
      } else {
        if (item?.dropDownData["npcCollegeCostProfile"]) {
          costofAttendanceList = item?.dropDownData["npcCollegeCostProfile"];
        }
      }
    }

    let meritScholerShipGrantList =
      this.universityList[i].dropDownData?.result?.totalGrant;

    if (meritScholerShipGrantList?.amount != undefined) {
      meritScholarShipAmt = meritScholerShipGrantList?.amount;
    }

    let affinityAmt = this.getAffinityAmount(
      this.universityList[i]?.dropDownData?.yearWiseAffinityQuestion
    );
    if (affinityAmt) {
      meritScholarShipAmt += affinityAmt;
    }

    let stateGrantData =
      this.universityList[i]?.dropDownData["result"]?.stateAid;
    let selectedStateCode =
      this.universityList[i]?.dropDownData?.StudentSelectedCollege;
    if (stateGrantData != undefined) {
      let grntAmt = Number(
        this.setStateAidandGrandAmount(stateGrantData, selectedStateCode)
      );
      meritScholarShipAmt += grntAmt;
    }

    for (let index = 0; index < costofAttendanceList.length; index++) {
      const row = costofAttendanceList[index];
      if (row.fieldNo == "50") {
        costOfAttendanceAmount = row.value;
      }
    }

    let outOfPocketCost = costOfAttendanceAmount - meritScholarShipAmt;
    // this.roundOfNumber(costOfAttendanceAmount) - this.roundOfNumber(meritScholarShipAmt);
    return outOfPocketCost > 0 ? outOfPocketCost : 0;
    // return Math.abs(outOfPocketCost);
  }

  getCostOfAttendanceHeaderAmount(item: any, i: number) {
    return item;
  }

  changeIpeds() {
    this.isIPEDSToggle = !this.isIPEDSToggle;
    this.getIpedsCostOfAttendanceData();
  }
  getCostOfAttendanceHeaderAmount1(item: any, i: string) {
    let objArr = [];
    let amount = 0;

    if (this.isShowNPCData[i] == true) {
      if (this.isIPEDSToggle == true) {
        if (item?.dropDownData["costOfAttendance"]) {
          objArr = item?.dropDownData["costOfAttendance"];
        }
      } else {
        if (item?.dropDownData["npcCollegeCostProfile"]) {
          objArr = item?.dropDownData["npcCollegeCostProfile"];
        }
      }
    } else {
      if (this.isIPEDSToggle == true) {
        if (item?.dropDownData["costOfAttendance"]) {
          objArr = item?.dropDownData["costOfAttendance"];
        }
      } else {
        if (item?.dropDownData["npcCollegeCostProfile"]) {
          objArr = item?.dropDownData["npcCollegeCostProfile"];
        }
      }
    }

    objArr.forEach((element) => {
      if (element.fieldNo == 50) {
        amount = element.value;
      }
    });
    return amount;
  }

  getErrorInCollegeCost(item: any, i: string) {
    let bool = false;

    if (this.isIPEDSToggle == false) {
      if (item?.dropDownData["IPEDSNPC"]?.NPC?.errorInCollegeCost == true) {
        bool = item?.dropDownData["IPEDSNPC"]?.NPC?.errorInCollegeCost;
      }
    }
    // }

    return bool;
  }

  getMeritHeaderAmount1(meritAmount: number, i: number) {
    let AffinityAmount = 0;
    let meritHearderAmount = 0;

    if (meritAmount != undefined && meritAmount != null) {
      meritHearderAmount += meritAmount;
    }

    let affinityAmt = this.getAffinityAmount(
      this.universityList[i]?.dropDownData?.yearWiseAffinityQuestion
    );
    if (affinityAmt) {
      meritHearderAmount += affinityAmt;
    }

    let stateGrantData =
      this.universityList[i]?.dropDownData["result"]?.stateAid;
    let selectedStateCode =
      this.universityList[i]?.dropDownData?.StudentSelectedCollege;
    if (stateGrantData != undefined) {
      let grntAmt = Number(
        this.setStateAidandGrandAmount(stateGrantData, selectedStateCode)
      );
      meritHearderAmount += grntAmt;
    }
    return meritHearderAmount;
  }

  checkAffinityYearWiseAvailable(yearWiseAffinityQuestion: any) {
    let yearWiseAffinity: any = [];

    if (yearWiseAffinityQuestion != undefined) {
      if (
        yearWiseAffinityQuestion &&
        yearWiseAffinityQuestion[this.year] != undefined
      ) {
        yearWiseAffinity = yearWiseAffinityQuestion[this.year];
      } else {
        if (
          yearWiseAffinityQuestion &&
          yearWiseAffinityQuestion[this.year - 1] != undefined
        ) {
          yearWiseAffinity = yearWiseAffinityQuestion[this.year - 1];
        }
      }
    }
    return yearWiseAffinity;
  }

  getAffinityAmount(yearWiseAffinity: any) {
    let AffinityAmount = 0;
    let yearWiseAffinityQuestion =
      this.checkAffinityYearWiseAvailable(yearWiseAffinity);
    if (yearWiseAffinityQuestion.length > 0) {
      if (
        yearWiseAffinityQuestion[0]?.AffinityQuestionSelectedAmount != undefined
      ) {
        AffinityAmount =
          yearWiseAffinityQuestion[0]?.AffinityQuestionSelectedAmount;
      }
    }

    return AffinityAmount;
  }

  checkPermissionShowStudentDeatils(fieldNo: number) {
    if (this.globalvar.isInternatinalStudent) {
      if (fieldNo != 6 && fieldNo != 40) {
        return true;
      } else {
        return false;
      }
    } else {
      if (fieldNo != 238) {
        return true;
      } else {
        return false;
      }
    }
  }
  // getInstGrantHeaderAmount()
  // {

  // }

  getMeritHeaderAmount(meritAmount: number, i: number) {
    let affinityAmt = this.getAffinityAmount(
      this.universityList[i]?.dropDownData?.yearWiseAffinityQuestion
    );
    if (affinityAmt) {
      meritAmount += affinityAmt;
    }

    return meritAmount;
  }

  private opentoolTipDialog = this.dialogService.open<any>(
    new PolymorpheusComponent(TooltippopupComponent, this.injector),
    {
      data: "",
      dismissible: false,
      label: "ToolTip",
      size: "m",
    }
  );

  openToolTipPopup(x: number) {
    let universitydata = this.checkAffinityYearWiseAvailable(
      this.universityList[x].dropDownData["yearWiseAffinityQuestion"]
    );
    this.opentoolTipDialog = this.dialogService.open<any>(
      new PolymorpheusComponent(TooltippopupComponent, this.injector),
      {
        data: universitydata,
        dismissible: true,
      }
    );
    this.opentoolTipDialog.subscribe({
      next: (data: any) => {},
      complete: () => {},
    });
  }

  private openCollegeSearchBox = this.dialogService.open<any>(
    new PolymorpheusComponent(CollegeNameSearchBoxComponent, this.injector),
    {
      data: "",
      dismissible: false,
      label: "",
      size: "s",
    }
  );

  openCollegeNameSearch(index: string) {
    this.openCollegeSearchBox = this.dialogService.open<any>(
      new PolymorpheusComponent(CollegeNameSearchBoxComponent, this.injector),
      {
        data: {
          index: index,
          changedCollege: this.universityList[index],
          searchAutoCompleteList: this.searchAutocompleteList,
        },
        dismissible: false,
      }
    );
    this.openCollegeSearchBox.subscribe({
      next: (data: any) => {
        if (
          data &&
          data.selectedColleges != undefined &&
          data.searchedColleges != undefined
        ) {
          this.universityList[index] = data.selectedColleges;
          this.searchAutocompleteList = data.searchedColleges;

          this.updateOcrScholarshipDataKeyList();
          this.updateOcrCoaDataKeyList();

          this.getCollegeWiseProgramList();
          // this.getROIDataByprogramWiseList(this.desiredStudeyModelValue);
          this.Comparision();
          this.getCollegeWiseAgeofEarningList();
          this.setOCRAwardLetterData(index);
          this.getInstGrantData(); //get merit and need data
          if (this.globalvar.isInternatinalStudent == false) {
            this.getFederalAidData(); //get federal and fseog data
            this.getStateAidData(); //get state grand
          }
          this.getIpedsCostOfAttendanceData(); //get cost of attendance data

          // }
        }
      },
      complete: () => {},
    });
  }

  // setOCRAwardLetterDataRavi(index: string) {
  //   if (this.universityList[index].hasOwnProperty("ocrDataScholarshipItems")) {
  //     if (
  //       Object.keys(this.universityList[index]["ocrDataScholarshipItems"])
  //         .length > 3
  //     ) {
  //       this.showOcrScholarshipsDataBucket[index] = true;
  //       this.showOcrData[index] = true;
  //       this.isShowIpedsData[index] = false;
  //     }
  //   } else {
  //     this.showOcrScholarshipsDataBucket[index] = false;
  //     this.showOcrData[index] = false;
  //     this.isShowIpedsData[index] = true;
  //   }

  //   if (this.universityList[index].hasOwnProperty("ocrDataCoaItems")) {
  //     if (
  //       Object.keys(this.universityList[index]["ocrDataCoaItems"]).length > 3
  //     ) {
  //       this.showOcrCoaDataBucket[index] = true;
  //       this.showOcrData[index] = true;
  //       this.isShowAwardLetterDDL[index] = true;
  //       this.isShowIpedsData[index] = true;
  //       this.isShowNPCData[index] = true;
  //       // this.isIPEDSToggle=true;
  //     }
  //   } else {
  //     this.showOcrCoaDataBucket[index] = false;
  //     this.showOcrData[index] = false;
  //     this.isShowIpedsData[index] = false;
  //     this.isShowNPCData[index] = false;
  //     // this.isIPEDSToggle=false
  //     this.isShowAwardLetterDDL[index] = false;
  //   }
  // }
  setOCRAwardLetterData(index: string) {
    const university = this.universityList[index];

    const hasScholarshipItems = university.hasOwnProperty(
      "ocrDataScholarshipItems"
    );
    const hasCoaItems = university.hasOwnProperty("ocrDataCoaItems");

    this.showOcrScholarshipsDataBucket[index] =
      hasScholarshipItems &&
      Object.keys(university["ocrDataScholarshipItems"]).length > 3;
    this.showOcrCoaDataBucket[index] =
      hasCoaItems && Object.keys(university["ocrDataCoaItems"]).length > 3;

    this.showOcrData[index] =
      this.showOcrScholarshipsDataBucket[index] ||
      this.showOcrCoaDataBucket[index];
    this.isShowAwardLetterDDL[index] = hasScholarshipItems || hasCoaItems;
    this.isShowIpedsData[index] = hasScholarshipItems || hasCoaItems;
    this.isShowNPCData[index] = hasCoaItems;
  }

  private openUniversitySummaryDialog = this.dialogService.open<any>(
    new PolymorpheusComponent(CollegeprofileComponent, this.injector),
    {
      data: "",
      dismissible: false,
      label: "ToolTip",
      // size: "auto",
    }
  );

  OpenUniversitySummaryDialog(university: any) {
    this.universityData = university;
    this.openUniversitySummaryDialog = this.dialogService.open<any>(
      new PolymorpheusComponent(CollegeprofileComponent, this.injector),
      {
        data: this.universityData,
        dismissible: false,
      }
    );
    this.openUniversitySummaryDialog.subscribe({
      next: (data: any) => {},
      complete: () => {},
    });
  }

  checkStateCalculatorExist(stateCode: string) {
    let stateCalculatorList = this.stateCalculatorList.filter(
      (el) => el.toLowerCase() == stateCode.toLowerCase()
    );

    if (stateCalculatorList.length > 0) {
      return true;
    } else {
      return false;
    }
  }
  ngOnInit() {
    let stateCalulatorAlreadyExists = this.globalvar.getAllStateList.get(
      "stateListStateCalculator"
    );
    if (stateCalulatorAlreadyExists.length > 0) {
      this.stateCalculatorList = stateCalulatorAlreadyExists;
    }

    let checkLogin =
      this.globalvar?.top5SubscriptionDashboardRequestData?.top5_request;

    if (checkLogin != undefined) {
      this.isMailMe = false;
    }
    this.basepath = this.globalvar.basepath;
    this.eventDataService.answerMap.subscribe(
      (answerValue: Map<Number, Answer>) => {
        if (answerValue) {
          this.answerMap = answerValue;
          this.getPageFormData();
          let program = this.answerMap.get(35);
          this.getProgramName(program.value);
          this.getProfileDetails();
          // let programName=this.answerMap.get(35);
          // this.programName = programName.label;
        }
      }
    );

    this.globalvar.saveChangesResultPage.subscribe((val: boolean) => {
      if (val == true) {
        this.sendMail("saveChanges");
      }
    });
    this.apiService.getFormData((res) => {});
    //Start :Commented On 07_Jun_2022

    // this.scholarshipService.get().subscribe(
    //   (res) => {
    //     this.loading = false;
    //     if (res.success) {
    //       if (this.dataService.universities.length > 0) {
    //         let scholarshipList = res.data.filter(
    //           (scholarship) =>
    //             this.dataService.universities.indexOf(scholarship.id) != -1
    //         );
    //         if (
    //           typeof res.data === "string" &&
    //           res.data == "User session is expired or not available"
    //         ) {
    //           this.successMessage = res.data;
    //         }
    //         this.scholarshipList = scholarshipList.slice(0, 5);

    //       } else {
    //         this.scholarshipList = res.data.slice(0, 5);

    //       }
    //       this.setSchoolarShipData(
    //         this.scholarshipList,
    //         this.scholarshipCOABreakDown,
    //         this.scholarshipBreakDown,
    //         this.scholarshipPellBreakDown,
    //         this.scholarshipStateBreakDown
    //       );

    //     } else {
    //       if (this.dataService.universities.length > 0) {
    //         let list = [];
    //         this.dataService.universityNames.forEach((scholarship) => {
    //           let col = { name: scholarship, grants: 0 };
    //           list.push(col);
    //         });
    //         this.scholarshipList = list.slice(0, 5);

    //         this.showBreakdown = false;
    //       }
    //     }
    //   },
    //   (err) => {
    //     this.loading = false;
    //     if (this.dataService.universities.length > 0) {
    //       let list = [];
    //       this.dataService.universityNames.forEach((scholarship) => {
    //         let col = { name: scholarship, grants: 0 };
    //         list.push(col);
    //       });
    //       this.scholarshipList = list.slice(0, 5);

    //       this.showBreakdown = false;
    //     }
    //   }
    // );

    //End :Commented On 07_Jun_2022
  }

  formatCur(val: string | number | unknown) {
    return this.codehelp.formatCurrencyRounOF(Number(val));
  }
  getProfileDetails() {
    let profileList = [];
    if (this.answerMap.size > 0) {
      this.predefineArray.profileList.forEach((element) => {
        let answerMap = this.answerMap.get(element.fieldNo);
        if (answerMap && answerMap.configId) {
          if (answerMap.fieldNo == 6) {
            let obj = {
              label: element.label,
              value: this.getSelectedStateCode(answerMap.value),
            };
            profileList.push(obj);
          } else if (answerMap.fieldNo == 32) {
            let obj = {
              label: element.label,
              value: answerMap.value,
            };
            let actdropdown = this.answerMap.get(32);
            if (actdropdown.value == "act") {
              let scoreact = this.answerMap.get(202);
              obj.value = scoreact.value;
            }
            if (actdropdown.value == "sat") {
              let scoresct = this.answerMap.get(201);

              obj.label = "SAT";
              obj.value = scoresct.value;
            }

            profileList.push(obj);
          } else if (answerMap.fieldNo == 266) {
            let obj = {
              label: element.label,
              value: answerMap.value,
            };

            profileList.push(obj);
          } else {
            let obj = {
              label: element.label,
              value: this.getConfigData(answerMap.configId, answerMap.value),
            };
            profileList.push(obj);
          }
        } else {
          if (answerMap) {
            // if(element.label=='GPA')
            // {
            //   let obj = {
            //     label: element.label,
            //     value: answerMap.value,
            //   };
            //     let gpaScale = this.answerMap.get(266);
            //   if (gpaScale.value == "4") {
            //     let gpaValue = this.answerMap.get(31);
            //     obj.value = gpaValue.value;
            //   }
            //   if (gpaScale.value == "5") {
            //     let gpaValue = this.answerMap.get(271);
            //     obj.value = gpaValue.value;
            //   }
            //   if (gpaScale.value == "12") {
            //     let gpaValue = this.answerMap.get(275);
            //     obj.value = gpaValue.value;
            //   }
            //   if (gpaScale.value == "100") {
            //     let gpaValue = this.answerMap.get(276);
            //     obj.value = gpaValue.value;
            //   }
            //   profileList.push(obj);

            // }

            if (answerMap.fieldNo == 5) {
              let obj = {
                label: element.label,
                value: this.SetContacFormate(answerMap.value),
              };
              profileList.push(obj);
            } else if (answerMap.fieldNo == 40) {
              let obj = {
                label: element.label == "EFC" ? "SAI" : "",
                value: this.formatCur(answerMap.value),
              };
              profileList.push(obj);
            } else {
              let obj = {
                label: element.label,
                value: answerMap.value,
              };
              profileList.push(obj);
            }
          }
        }
      });
    }

    this.studentProfileArr = profileList;
  }
  // getProfileDetails() {
  //   let profileList = [];
  //   if (this.answerMap.size > 0) {
  //     this.predefineArray.profileList.forEach((element) => {
  //       let answerMap = this.answerMap.get(element.fieldNo);
  //       if (answerMap && answerMap.configId) {
  //         if (answerMap.fieldNo == 6) {
  //           let obj = {
  //             label: element.label,
  //             value: this.getSelectedStateCode(answerMap.value),
  //           };
  //           profileList.push(obj);
  //         } else if (answerMap.fieldNo == 32) {
  //           let obj = {
  //             label: element.label,
  //             value: answerMap.value,
  //           };
  //           let actdropdown = this.answerMap.get(32);
  //           if (actdropdown.value == "act") {
  //             let scoreact = this.answerMap.get(202);
  //             obj.value = scoreact.value;
  //           }
  //           if (actdropdown.value == "sat") {
  //             let scoresct = this.answerMap.get(201);

  //             obj.label = "SAT";
  //             obj.value = scoresct.value;
  //           }

  //           profileList.push(obj);
  //         } else if (answerMap.fieldNo == 266 || answerMap.fieldNo == 32) {
  //           let obj = {
  //             label: element.label,
  //             value: answerMap.value,
  //           };
  //           let gpaScale = this.answerMap.get(266);
  //           if (gpaScale.value == "4") {
  //             let gpaValue = this.answerMap.get(31);
  //             obj.value = gpaValue.value;
  //           }
  //           if (gpaScale.value == "5") {
  //             let gpaValue = this.answerMap.get(271);
  //             obj.value = gpaValue.value;
  //           }
  //           if (gpaScale.value == "12") {
  //             let gpaValue = this.answerMap.get(275);
  //             obj.value = gpaValue.value;
  //           }
  //           if (gpaScale.value == "100") {
  //             let gpaValue = this.answerMap.get(276);
  //             obj.value = gpaValue.value;
  //           }
  //           profileList.push(obj);
  //         } else {
  //           let obj = {
  //             label: element.label,
  //             value: this.getConfigData(answerMap.configId, answerMap.value),
  //           };
  //           profileList.push(obj);
  //         }
  //       } else {
  //         if (answerMap) {
  //           if (answerMap.fieldNo == 5) {
  //             let obj = {
  //               label: element.label,
  //               value: this.SetContacFormate(answerMap.value),
  //             };
  //             profileList.push(obj);
  //           } else if (answerMap.fieldNo == 40) {
  //             let obj = {
  //               label: element.label,
  //               value: this.formatCur(answerMap.value),
  //             };
  //             profileList.push(obj);
  //           } else {
  //             let obj = {
  //               label: element.label,
  //               value: answerMap.value,
  //             };
  //             profileList.push(obj);
  //           }
  //         }
  //       }
  //     });
  //   }

  //   this.studentProfileArr = profileList;
  //   console.log("profileList", profileList);
  // }

  getCardViewArrayList() {
    // console.log(this.universityList, "universityList");
    const mergedList = [...this.searchAutocompleteList, ...this.universityList];

    return mergedList;
  }
  cardviewView() {
    this.isCartView = true;
  }
  tableview() {
    this.isCartView = false;
    this.getCollegeData();
  }
  getPageFormData() {
    let filterFileds = [266, 32, 202, 31, 201, 271, 275, 276, 35];
    let data = this.answerMap;

    this.componentPageData = [];
    this.answerMap.forEach((element) => {
      if (filterFileds.includes(element.fieldNo)) {
        this.componentPageData.push(element);
      }
    });
  }

  getActSatLabel(label: string) {
    if (label == "act") {
      return "ACT";
    }
    if (label == "sat") {
      return "SAT";
    }
    // if (label == "Desired Field of Study") {
    //   return "Desired Field of Study";
    // }
  }
  getDesiredLabel(label: string) {
    // if (label == "act") {
    //   return "ACT";
    // }
  }
  getFormValue(value: string) {
    if (value == "act") {
      let scoreact = this.answerMap.get(202);
      return scoreact.value;
    }
    if (value == "sat") {
      let scoresct = this.answerMap.get(201);
      return scoresct.value;
    }
    // if (value == "Desired Field of Study") {
    //   let Desired = this.answerMap.get(201);
    //   return Desired.value;
    // }
    // if (value == "4") {
    //   let gpaValue = this.answerMap.get(31);
    //   return  gpaValue.value;
    // }
    // if (value == "5") {
    //   let gpaValue = this.answerMap.get(271);
    //   return  gpaValue.value;
    // }
    // if (value == "12") {
    //   let gpaValue = this.answerMap.get(275);
    //   return  gpaValue.value;
    // }
    // if (value == "100") {
    //   let gpaValue = this.answerMap.get(276);
    //   return  gpaValue.value;
    // }
  }

  ngOnDestroy() {}

  roundOfNumber(num: string | number) {
    return Math.ceil(Number(num) / 100) * 100;
  }

  getOuOfPocketAmountForOCR(i: number) {
    let outOfPocketCostOCR = 0;
    let coaAmount = this.universityList[i]?.ocrDataCoaSum;
    let meritScholarShipAmt = this.universityList[i]?.ocrDataScholarshipsSum;
    if (coaAmount != undefined && meritScholarShipAmt != undefined) {
      outOfPocketCostOCR = coaAmount - meritScholarShipAmt;
      // this.roundOfNumber(coaAmount) - this.roundOfNumber(meritScholarShipAmt);
    }
    return outOfPocketCostOCR > 0 ? outOfPocketCostOCR : 0;
  }

  keepOrder(a, b) {
    return a;
  }

  convertArry(a: string) {
    return a.split(" ");
  }

  openModalWithClass(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: "gray modal-md" })
    );
  }

  close() {
    // this.router.navigate([this.basepath + '/home/feedback']);
    this.modalRef.hide();
  }

  getProgramName(val: string) {
    let programName = this.getConfigData("programCategory", val);
    this.programName = programName;
  }
  openfeedback() {
    this.router.navigate(["/home/feedback"]);
    this.modalRef.hide();
  }

  openModal2WithClass(template: TemplateRef<any>, university: any) {
    //this.universitySummaryData= university.summaryData;

    this.universityData = university;

    const data = this.universityData;
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: "gray modal-lg", data })
    );
  }

  isSticky: boolean = false;
  @HostListener("window:scroll", ["$event"])
  checkScroll($event) {
    this.isSticky = window.pageYOffset >= 70;
  }
  getColor(color: any) {
    if (color) {
      if (color.sum) return null;
      else return null;
    } else return null;
  }

  previous() {
    this.globalvar.initialiseStateMapSubjectBehaviour();
    let pno = --this.globalvar.stepper.page;
    this.globalvar.redirectPage(pno, true, false, true);
    this.globalvar.saveChangedDeduct = false;

    // this.globalvar.change(Number(pno));
    // this.router.navigate(["/home/steps/" + Number(pno)]);
    // this.globalvar.handleSaveData(true);

    // let extrapno = --this.globalvar.extraPagestepper.page;
    // this.globalvar.hanleExtraPageAndUrl(extrapno);
  }
  setValueWithPercentage(val: string) {
    return Math.ceil(Number(val) * 100) + "%";
  }
  // setValueWithPercentage(val: any) {
  //   const numericValue = Number(val);

  //   if (!isNaN(numericValue)) {
  //     return Math.ceil(numericValue * 100) + "%";
  //   } else {
  //     return "-";
  //   }
  // }

  nan(value) {
    return isNaN(value);
  }

  SetContacFormate(val: string) {
    const regex = new RegExp(/[^0-9]/g);
    val = val.replace(regex, "");
    return this.codehelp.formatNumerWithType(val, "USA");
  }

  getSelectedStateCode(value: string) {
    //let studentState = this.getFieldValue(fieldNo);
    let collegelist = this.getCardViewArrayList();
    let stateList = [];
    stateList.push(value);
    collegelist.forEach((item) => {
      if (item?.dropDownData?.StudentSelectedCollege?.stateCode) {
        if (item?.dropDownData?.StudentSelectedCollege?.domicileAndResidency) {
          let checkList =
            this.predefineArray.studentProfileStateCodeInstate.some(
              (el) =>
                el.value ==
                item?.dropDownData?.StudentSelectedCollege?.domicileAndResidency
            );
          if (checkList) {
            stateList.push(
              item?.dropDownData?.StudentSelectedCollege?.stateCode
            );
          }
        }
      }
    });
    const unqueiArr = [...new Set(stateList.map((item) => item.toUpperCase()))];
    return unqueiArr.toString();
  }

  getFieldValue(fieldno: number) {
    if (this.answerMap != undefined) {
      let field = this.answerMap.get(fieldno);
      if (field != undefined) {
        if (fieldno == 5) {
          let val = field.value.replace(/\D/g, "");
          val = this.codehelp.formatNumerWithType(val, "USA");
          return val;
        } else {
          if (fieldno == 1 || fieldno == 2 || fieldno == 13) {
            field.value = this.firstLetterUpper(field.value);
          }
          // if (fieldno == 6) {
          //   return "mn";
          // } else {
          return field.value;
          // }
        }
      }
      return "";
    }
  }

  updateOcrScholarshipDataKeyList() {
    this.ocrScholarshipsDataList = [];
    for (let index = 0; index < this.universityList.length; index++) {
      if (
        !this.universityList[index].hasOwnProperty("ocrDataScholarshipItems")
      ) {
        continue;
      }
      let ocrDataKeys = Object.keys(
        this.universityList[index]["ocrDataScholarshipItems"]
      );
      ocrDataKeys.forEach((item) => {
        if (
          item != "id" &&
          item != "name" &&
          item != "" &&
          item != "ipedsId" &&
          !this.ocrScholarshipsDataList.some((e) => e.value === item)
        ) {
          this.ocrScholarshipsDataList.push({ value: item, label: item });
        }
      });
    }
  }

  updateOcrCoaDataKeyList() {
    this.ocrCoaDataList = [];
    for (let index = 0; index < this.universityList.length; index++) {
      if (!this.universityList[index].hasOwnProperty("ocrDataCoaItems")) {
        continue;
      }
      let ocrDataKeys = Object.keys(
        this.universityList[index]["ocrDataCoaItems"]
      );
      ocrDataKeys.forEach((item) => {
        if (
          item != "id" &&
          item != "name" &&
          item != "" &&
          item != "ipedsId" &&
          !this.ocrCoaDataList.some((e) => e.value === item)
        ) {
          this.ocrCoaDataList.push({ value: item, label: item });
        }
      });
    }
  }

  onChangeOcrDataDropDown(event: any, index: number) {
    this.showOcrData[index] = event.target.value === "ocrData" ? true : false;
    this.isShowNPCData[index] = event.target.value === "top5" ? true : false;
    // this.isIPEDSToggle = event.target.value === "ipeds" ? true : false;
    // if (event.target.value === "top5") {
    // this.getNPCCostOfAttendanceData();
    this.getIpedsCostOfAttendanceData();
    this.getInstGrantData(); //get merit and need data
    if (this.globalvar.isInternatinalStudent == false) {
      this.getFederalAidData(); //get federal and fseog data
      this.getStateAidData(); //get state grand
    }
    // }
    // else {
    //   if (event.target.value === "ipeds") {
    //     this.getIpedsCostOfAttendanceData();
    //   }
    // }
  }

  gettotalFederalAid(i: number) {
    let totalFederalAid =
      this.universityList[i]?.dropDownData?.result?.federalAid?.totalFederalAid;
    let selectedStateCode =
      this.universityList[i]?.dropDownData?.StudentSelectedCollege;
    let cssProfileEFC = this.universityList[i]?.summaryData?.cssProfileEFC;
    if (totalFederalAid != undefined) {
      return this.setStateFederalIncludedAndEligibalAmount1(
        totalFederalAid,
        cssProfileEFC
      );
    } else {
      return 0;
    }
  }

  gettotalStateAid(i: number) {
    let totalStateAid = this.universityList[i]?.dropDownData?.result?.stateAid;
    let selectedStateCode =
      this.universityList[i]?.dropDownData?.StudentSelectedCollege;
    let cssProfileEFC = this.universityList[i]?.summaryData?.cssProfileEFC;
    if (totalStateAid != undefined) {
      return this.setStateIncludedAndEligibalAmount(
        totalStateAid,
        selectedStateCode,
        cssProfileEFC
      );
    } else {
      return 0;
    }
  }

  getValue(configId, value) {
    if (this.answerMap != undefined) {
      if (configId == "studentEthinicity" && value) {
        let data;
        let returnStr;
        let index = 0;
        for (const item of value) {
          if (index == 0) {
            returnStr = " ";
          }
          if (index !== 0) {
            returnStr += ", ";
          }
          data = dropdownValues[configId].find((v) => v.value == item);
          if (data.label != undefined) {
            returnStr += data.label;
          }
          index++;
        }
        return returnStr;
      }
      if (configId && value) {
        let data = dropdownValues[configId].find((v) => v.value == value);
        return data.label;
      } else {
        return value;
      }
    }
  }

  getConfigData(configId, value) {
    if (this.answerMap != undefined) {
      if (configId == "studentEthinicity") {
        let configVal = value.split(",");
        let configFieldLabel: Array<String> = [];
        for (let index = 0; index < configVal.length; index++) {
          const configValue = configVal[index];
          let elem: Array<Searchconfig> =
            this.configmap.configMap.get(configId || "") || [];
          const valData = elem.find((element) => {
            return element.value == configValue;
          });
          configFieldLabel.push(valData?.label);
          // configFieldLabel+= +','+valData?.label || '';
        }
        return configFieldLabel.toString();
      } else {
        let elem: Array<Searchconfig> =
          this.configmap.configMap.get(configId || "") || [];
        if (configId == "programCategory") {
          this.desiredStudeyDDL = elem;
          this.desiredStudeyModelValue = value;
        }
        const valData = elem.find((element) => {
          return element.value == value;
        });
        return valData?.label || "";
      }
    }
  }

  changeProgram(modalValue: string, selectedValue: string) {
    this.getProgramName(selectedValue);
    // this.getROIDataByprogramWiseList(selectedValue);
    this.getROIDataForAllCollegeAgeofEarningList(selectedValue);
  }
  @HostListener("window:scroll", ["$event"])
  onWindowScroll(e) {
    let element = document.getElementById("stickyHeaderAvg");
    let element1 = document.getElementById("stickyHeaderAvgTableRow"); // to get offset
    if (element1) {
      // console.log(element, window.pageYOffset, element1);
      // console.log(window.pageYOffset , element1.offsetTop , element.clientHeight)
      // console.log(window.pageYOffset > (element1.offsetTop - element.clientHeight), (window.pageYOffset < (element1.offsetTop + element1.clientHeight - 100)));
      // if (window.pageYOffset > (element1.offsetTop - (element.clientHeight + element.offsetHeight)) && (window.pageYOffset < (element1.offsetTop + element1.clientHeight))) {
      if (
        window.pageYOffset > element1.offsetTop - element.clientHeight + 20 &&
        window.pageYOffset < element1.offsetTop + element1.clientHeight - 20
      ) {
        element.classList.add("sticky");
      } else {
        element.classList.remove("sticky");
      }
    }
  }

  firstLetterUpper(strOption) {
    var str = strOption
      .toLowerCase()
      .replace(/(^\s*\w|[\.\!\?]\s*\w)/g, function (c) {
        return c.toUpperCase();
      });
    return str;
  }
  private opennote = this.dialogService.open<any>(
    new PolymorpheusComponent(ResultNotepopupComponent, this.injector),
    {
      dismissible: false,
      label: "",
      // size: "l",
    }
  );

  resultnote() {
    this.opennote = this.dialogService.open<any>(
      new PolymorpheusComponent(ResultNotepopupComponent, this.injector),
      {
        data: "",
        dismissible: false,
        // size: "l",
      }
    );
    this.opennote.subscribe({
      next: (data: any) => {},
      complete: () => {},
    });
  }

  checkOutStateGridData(item: any, index: string) {
    let outStateGridNotUsed = false;
    let preferOutStateGrid = false;
    let val = false;
    if (item.dropDownData?.result?.preferOutStateGrid != undefined) {
      preferOutStateGrid = item.dropDownData?.result?.preferOutStateGrid;
    }
    let meritName = item.dropDownData?.result?.institutionalGrants;
    Object.keys(meritName).forEach((key) => {
      if (meritName[key]?.outStateGridUsed != undefined) {
        outStateGridNotUsed =
          meritName[key]?.amount > 0 &&
          meritName[key]?.outStateGridUsed == false &&
          preferOutStateGrid == true
            ? true
            : false;
        if (outStateGridNotUsed) {
          val = outStateGridNotUsed;
          // return  outStateGridNotUsed;
        }
      }
    });

    return val;
  }
}
